import {
    APP_TITLE,
    LANDING_BRIEF,
    LANDING_LANGUAGE_SELECTOR,
    LANDING_COUNTRY_SELECTOR,
    LANDING_TERMS,
    LANDING_TERMS_ERROR,
    LANDING_CAPTCHA_ERROR,
    BUTTON_PREV,
    BUTTON_NEXT,
    BUTTON_SUBMIT,
    MENU_FEEDBACK_FORM,
    MENU_FEEDBACK_STATUS,
    MENU_FORM_INTAKE,
    MENU_FORM_EVENT_DETAILS,
    MENU_FORM_PRODUCT_INFO,
    SYSTEM_FEEDBACK_FORM,
    SYSTEM_FEEDBACK_STATUS,
    FORM_TITLE,
    FORM_MANDATORY_FIELDS,
    APP_DESCRIPTION,
    SUBMIT_FEEDBACK,
    CHECK_SUBMITTED_FEEDBACK,
    BTN_LAUNCH_FORM,
    BTN_CHECK_STATUS,
    SELECT_RESPONSE,
    FUNCTION_ROLE,
    CUSTOMER_ACCOUNT_NUMBER,
    ENTER_CUSTOMER_ACCOUNT,
    HELP_CUSTOMER_ACCOUNT_NUMBER,
    EVENT_REPORTED,
    REFERENCE_NUMBER,
    ENTER_REFERENCE,
    WHO_REPORTED_TO,
    WHO_WAS_NOTIFIED,
    ENTER_NAME,
    PRODUCT_SURVEILLANCE,
    YOUR_NAME,
    OCCUPATION,
    PHONE_NUMBER,
    ENTER_PHONE_NUMBER,
    ENTER_EMAIL,
    EMAIL_ADDRESS,
    ENTER_ADDRESS,
    ENTER_NA_IF_UNKNOWN,
    FACILITY_HOSPITAL,
    ENTER_FACILITY,
    ADDRESS_1,
    ADDRESS_2,
    CITY,
    STATE,
    POSTAL_CODE,
    COUNTRY,
    END_USER_CUSTOMER,
    ADDITIONAL_CONTACT_PERSON,
    ADDITIONAL_PHONE,
    ADDITIONAL_EMAIL,
    ANOTHER_FACILITY_ADDRESS,
    ANOTHER_FACILITY_HOSPITAL,
    ANOTHER_ENTER_FACILITY,
    ANOTHER_ADDRESS_1,
    ANOTHER_ADDRESS_2,
    ANOTHER_CITY,
    ANOTHER_STATE,
    ANOTHER_POSTAL_CODE,
    ANOTHER_COUNTRY,
    LOT_SERIAL_NUMBER,
    ENTER_LOT_SERIAL_NUMBER,
    HELP_LOT_SERIAL_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
    PRODUCT_CODE,
    ENTER_PRODUCT_CODE,
    HELP_PRODUCT_CODE,
    NDC,
    ENTER_NDC,
    UDI,
    ENTER_UDI,
    PRODUCT_NAME,
    ENTER_PRODUCT_NAME,
    HELP_PRODUCT_NAME,
    BEST_DESCRIBES,
    QUANTITY_TO_SELECT,
    ENTER_QUANTITY,
    HELP_QUANTITY,
    UNIT,
    AVAILABLE_TO_RETURNED,
    PHOTOGRAPH_AVAILABLE,
    HELP_PHOTOGRAPH_AVAILABLE,
    UPLOAD_IMAGES,
    REPORTER_NAME,
    REPORTER_FACILITY,
    REPORTER_OCCUPATION,
    ENTER_NUMBER,
    REPORTER_PHONE_NUMBER,
    REPORTER_EMAIL_ADDRESS,
    EMPLOYEE_NAME,
    EMPLOYEE_PHONE_NUMBER,
    EMPLOYEE_EMAIL_ADDRESS,
    RETURNING_FOR_INVESTIGATION,
    HELP_RETURNING_FOR_INVESTIGATION,
    UNUSED_BAXTER_PRODUCT,
    YOU_INDICATED_SAMPLES,
    SAMPLE_RETURN_KIT,
    A_BOX_WITH_A_PREPAID_LABEL,
    SAME_AS_MY_ADDRESS,
    OTHER_CONTACT_NAME,
    OTHER_CONTACT_OCCUPATION,
    OTHER_CONTACT_PHONE_NUMBER,
    OTHER_CONTACT_EMAIL_ADDRESS,
    MANUFACTURED_BY_ANOTHER_COMPANY,
    CUSTOMER_EXPLICITLY_REQUEST,
    EXPLICITLY_REQUEST_CREDIT,
    PRODUCT_FROM_BAXTER,
    QUANTITY_REQUESTED_CREDIT,
    ENTER_OCCUPATION,
    LOT_QUANTITY_NUMBER,
    WHOLESALERS_NAME,
    PLACE_WHOLESALERS_NAME,
    DATE_OF_EVENT,
    DATE_OF_EVENT_MSG,
    HELP_DATE_OF_EVENT,
    DATE_BAXTER_EMPLOYEE,
    DATE_MESSAGE_BAXTER_EMPLOYEE,
    DURING_WHAT_PROCESS,
    WAS_THE_PATIENT,
    WERE_YOU_CONNECTED,
    PROVIDE_ANY_ADDITIONAL,
    HELP_YOU_IDENTIFIED_MORE,
    ENTER_DETAILS,
    PROVIDE_ANY_ATTACHMENT,
    WAS_NEGATIVE_MEDICAL,
    WAS_MEDICAL_INTERVENTION,
    PROVIDE_DETAILS,
    REQUIRED_TREATMENT,
    ENTER_TREATMENT,
    RELEVANT_TESTS,
    HELP_RELEVANT_TESTS,
    RELEVANT_MEDICAL_HISTORY,
    ENTER_HISTORY,
    PATIENT_NAME,
    PATIENT_INITIALS,
    PATIENT_PHONE_NUMBER,
    PATIENT_EMAIL_ADDRESS,
    I_DO_NOT_WISH_TO_PROVIDE,
    PATIENT_ADDRESS,
    SAME_ADDRESS,
    DRUG_BEING_USED,
    PATIENT_IDENTIFIER,
    PATIENT_AGE_OR_DOB,
    ENTER_PATIENT_AGE,
    PATIENT_GENDER,
    PATIENT_WEIGHT,
    ENTER_WEIGHT,
    PATIENT_WEIGHT_UNIT,
    MY_NAME,
    ENTER_IN_YOUR_CONTACT,
    MY_PHONE_NUMBER,
    MY_EMAIL_ADDRESS,
    MY_ADDRESS,
    NAME_OF_BAXTER_DRUG,
    ENTER_DRUG_NAME,
    PLEASE_PROVIDE_THE_NAME,
    APPLY_TO_EACH_UNIT,
    SELECT_THE_COMPONENT,
    USE_THE_DIAGRAM,
    TYPE_OF_DAMAGE,
    PLEASE_ENTER_VALUE,
    WAS_THE_PRODUCT_KINKED,
    WERE_ANY_CLEANING,
    WHAT_WAS_THE_DISINFECTANT,
    NOTE_BAXTER_LABELING,
    SELECT_ALL_THAT_APPLY,
    DID_FOLLOWING_OCCUR,
    SELECT_THE_LOCATION,
    WAS_THE_PRODUCT_EXPOSED,
    HOW_LONG_TRANSFER,
    WAS_THERE_DIFFICULTY,
    WAS_DEVICE_OR_TOOL,
    DESCRIBE_HOW_PRODUCT,
    DID_YOU_OBSERVE,
    WERE_DIFFICULTIES_PUTTING,
    WAS_THE_TRANSFER,
    SELECT_TYPE_OF_FLOW,
    WAS_ANYTHING_BLOCKING,
    WAS_ANY_ALARM,
    SELECT_BEST_DESCRIBE,
    WERE_THE_MINICAPS,
    WAS_THE_SPONGE_VISIBLE,
    WHERE_PARTICULATE_MATTERFOREIGN,
    DESCRIBE_THE_EXACT_LOCATION,
    WAS_THE_PARTICULATE_MATTER,
    DOES_THE_PARTICULATE_MATER,
    WHAT_COMPONENT_DOES,
    SELECT_CONNECTION_ISSUE,
    WERE_ASSIST_DEVICES,
    WERE_ANY_DIFFICULTIES,
    PROVIDE_PRODUCT_INFORMATION,
    WERE_THE_SPIKE_LUER,
    BAXTER_LABELING_STATES,
    WERE_PETS_OR_ANIMALS,
    BAXTER_LABELING_CONTAMINATION,
    WERE_OTHER_ISSUES,
    WAS_MINICAP_TWISTED,
    WERE_DIFFICULTIES_TRANSFER_SET,
    DID_TRANSFER_SET_CONNECTORS,
    WHAT_WAS_THE_ALARM,
    WHERE_OBSERVED_DAMAGE,
    SELECT_THE_TYPE_OBSERVED,
    DID_DAMAGE_CAUSE_LEAK,
    WAS_THE_SHIPPING_CARTON,
    SELECT_FLOW_ISSUE_OBSERVED,
    HOW_LONG_WAS_STORAGE,
    WAS_THERE_AN_ADAPTER,
    NAME_AND_MODEL,
    NAME_VAPORIZER,
    WAS_VIAL_INVERTED,
    WHAT_VIAL_USED,
    DRUG_NAME_MANUFACTURER,
    WERE_BREAK_FRANGIBLE,
    WAS_ALARM_ASSOCIATED,
    WHAT_PART_DISCOLORED,
    DESCRIBE_DISCOLORATION,
    HOW_PRODUCT_STORED,
    DOES_DISCOLORATION_APPEAR,
    WHICH_CHAMBER_DISCOLORED,
    WAS_PEEL_SEAL_INTERCHAMBER,
    WAS_DISCOLORATION_NOTICED,
    SELECT_SPECIFICALLY_DESCRIBES,
    WHAT_DEVICE_HAD_ALARM,
    WHAT_MISSING_MISASSEMBLED,
    RECONSTITUTION_ISSUE,
    WHAT_MEDICATION_SOLUTION,
    WHAT_VOLUME_MEDICATION,
    WHAT_DEVICES_RECONSTITUTION,
    WAS_PRODUCT_EXPOSED_HEAT,
    DESCRIBE_EXPOSURE,
    WHAT_USED_ACTIVATE_SOLUTION,
    WAS_DAMAGE_OBSERVED,
    DESCRIBE_THE_DAMAGE,
    APPROXIMATELY_SOLUTION_POWDER,
    WAS_LEAK_OBSERVED,
    WHAT_FEATUR_DIFFICULT_USE,
    HOW_WAS_DIFFICULT_USE,
    WHERE_MATTER_FOREIGN,
    DOES_PARTICULATE_MATTER,
    DESCRIBE_EXACT_LOCATION,
    WAS_MATTER_FOREIGN,
    WHEN_MATTER_FOREIGN,
    PROVIDE_INFORMATION_MEDICATION,
    PRODUCT_NAME_CODE_NUMBER,
    DESCRIBE_SPIKING,
    INCLUDE_NEEDLE,
    WHAT_ADMINISTRATION_RECONSTITUTION,
    INCLUDE_MANUFACTURER,
    WAS_MEDICATION_ADDITIVE,
    WHAT_MEDICATION_ADDITIVE,
    WHAT_STATE_OF_PRODUCT,
    AFTER_UNITS_SAT,
    DID_ATTEMPT_AGITATE,
    DID_PRECIPITATE_DISSOLVE,
    WHAT_STORAGE_TEMPERATURE,
    PROVIDE_TEMPERATURE_LOCATION,
    ARE_TEMPERATURE_LOGS,
    LOGS_CAN_BE_ATTACHED,
    IS_THE_STORAGE_UNIT,
    HOW_PRODUCT_THAWED,
    WHAT_STORAGE_CONDITIONS,
    WAS_ANY_DAMAGE,
    MORE_SPECIFIC_INFORMATION,
    WHAT_PURPOSE_INDICATION,
    WHAT_ROUTE_ADMINISTRATION,
    WHAT_DATE_ADMINISTRATION,
    WHAT_DOSAGE_STRENGTH,
    WAS_RECENT_PRESCRIPTION,
    WHAT_WAS_STORAGE_TEMPERATURE,
    WERE_ANY_ADJUSTMENTS,
    SELECT_APPROPRIATE_DESCRIPTION,
    SELECT_LABELING_ISSUE,
    WAS_CONNECTION_SECURE,
    WAS_EXPIRED_PRODUCT,
    WAS_COMPONENT_DAMAGED,
    WERE_ABNORMALITIES_DAMAGE,
    WHAT_PURCHASE_ORDER_NUMBER,
    WHAT_DATE_OF_ADMINISTRATION,
    WHAT_WAS_EXPIRATION_DATE,
    DESCRIBE_WAS_INCORRECT,
    WHAT_SCANNER_USED,
    WAS_OVERPOUCH_POUCH,
    WHAT_BACKGROUND_COLOR,
    DO_ALL_OF_THE_LABELS,
    PRODUCT_INFORMATION,
    IS_A_BARCODE_SCANNER,
    HOW_ARE_THESE_PRODUCTS,
    WHAT_INFORMATION_INCORRECTLY,
    WAS_THERE_LEAK,
    WHERE_LEAK_OBSERVED,
    WAS_FRANGIBLE_OBSERVED,
    IS_MOISTURE_CLEAR,
    WHO_IS_YOUR_DISTRIBUTOR,
    WHAT_MANUFACTURER_MEDICATION,
    WHAT_GAUGE_NEEDLE,
    WHAT_ADMINISTRATION_SET,
    WAS_DIFFICULTY_SPIKING,
    WERE_FOLLOWING_SCENARIOS,
    WAS_FRANGIBLE_OBSERVED_DEFECT,
    WHAT_AMOUNT_PRESSURE,
    WAS_BAG_COMPLETELY,
    WHAT_MANUFACTURER_MODEL,
    WHAT_PRESSURE_PRIOR,
    LIST_THE_VAPORIZER,
    APPROXIMATELY_HOW_MUCH,
    WAS_THE_BOTTLE_DIFFICULT,
    WERE_VISIBLE_DEFECTS,
    SELECT_THE_OPTION,
    PROVIDE_INVOLVED_CONNECTION_ISSUE,
    WHICH_PART_SEPARATED,
    WHAT_COMPONENT_DISCOLORED,
    SELECT_DESCRIBES_DISCOLORATION,
    WAS_THE_SET_DISCOLORED,
    DID_SET_CHANGE_COLOR,
    WHAT_MEDICATION_ADDED,
    WHERE_MATERIAL_LOCATED,
    DESCRIBE_APPEARANCE_COLOR_SIZE,
    WAS_EMBEDDED_PLASTIC,
    WAS_THERE_A_PRECIPITATE,
    WHAT_MEDICATIONS_SOLUTIONS,
    WHERE_DAMAGE_COMPONENT_AFFECTED,
    WHAT_DAMAGE_ISSUE,
    DID_ISSUE_RESULT,
    WAS_PATIENT_CONNECTED,
    WAS_PRODUCT_REPLACED,
    WHICH_SITUATION_BEST,
    SELECT_MOST_LABELING_ISSUE,
    WHAT_INFORMATION_DISPLAYED,
    WHAT_SCANNER_WAS_USED,
    INCLUDE_THE_MODEL_NAME,
    WAS_PRODUCT_ORDERED,
    WHERE_LEAK_COMING,
    DID_SCENARIOS_OCCURRED_LEAK,
    WAS_POWER_INJECTOR,
    WHAT_INJECTOR_USED,
    MANUFACTURER_NAME_CODE_LOT,
    DESCRIBE_INCORRECT_INCOMPLETE,
    PROVIDE_INFORMATION_SECOND_PRODUCT,
    WHICH_COMPONENTS_WERE_FOUND,
    DESCRIBE_CUT_HOLE_SLICE,
    WAS_LEAK_ORIGINATING,
    PROVIDE_DISCONNECTION_CONNECTION,
    WHICH_SPECIFIC_BONDED,
    WERE_VISIBLE_IRREGULARITIES,
    WAS_SUCCESSFUL_CONNECTION,
    WAS_TOOL_USED_ASSIST,
    WERE_LUER_CONNECTIONS,
    WAS_PRODUCT_SECURELY,
    WHICH_DESCRIBES_FLOW_ISSUE,
    WHAT_FLOWING_BACKWARDS,
    DESCRIBE_COMPONENTS_BACKFLOW,
    DO_SITUATIONS_APPLY,
    WHICH_SPECIFIC_AREA,
    WAS_FLOW_PREVIOUSLY_SEEN,
    WAS_ANY_FOLLOWING_OBSERVED,
    WHERE_SIMULTANEOUS_FLOW,
    WHAT_TYPE_HANGER,
    WHAT_WAS_HANGER_LENGTH,
    WHICH_BAG_LOWER,
    WHAT_Y_SITE_WAS,
    WHAT_COMPONENT_WITHIN,
    WAS_COMPONENT_SET_REPLACED,
    WHAT_VOLUME_FLUID_PERIOD_TIME,
    WHAT_VOLUME_FLUID_OVER_TIME,
    WAS_USED_WITH_PUMP,
    DID_CLAMP_FAIL,
    WHAT_CLAMP_FAILED,
    WAS_ISSUES_OBSERVED_CLAMP,
    DO_OTHER_SITUATIONS_DESCRIBE,
    DESCRIBE_ALARM_OBSERVED,
    INCLUDE_ANY_MESSAGES,
    WHICH_CLAMP_HAD_ISSUE,
    WHICH_TYPE_CLAMP_ISSUE,
    SELECT_BEST_DESCRIBES_ISSUE,
    PROVIDE_MORE_DETAILS,
    PROVIDE_MORE_DETAILS_INSTRUCTIONS,
    DESCRIBE_THE_SMELL,
    WAS_ISSUES_WITH_SET,
    WHERE_LEAK_LOCATED,
    DID_OCCUR_WITH_LEAK,
    PROVIDE_INVOLVED_DISCONNECTION,
    DID_OCCURRED_WITH_THE_LEAK,
    WHERE_WAS_PRODUCT_DAMAGED,
    SELECT_ALL_APPLY,
    DESCRIBE_OBSERVED_DAMAGE,
    WHAT_COMPONENT_IS_DISCOLORED,
    DESCRIBE_HUE_TINT_SHADE,
    INSIDE_OUTSIDE_OVERPOUCH,
    DESCRIBE_EXACT_LOCATION_SIZE,
    DOES_THE_PARTICULATE_MATTER,
    WAS_PARTICULATE_MATERIAL_EMBEDDED,
    DOES_APPEAR_PRODUCT_MATERIAL,
    WHERE_DID_THE_ISSUE_OCCUR,
    LIST_COMPONENTS_IF,
    WERE_THERE_VISIBLE_IRREGULARITIES,
    SELECT_OPTION_FLOW_ISSUE,
    DESCRIBE_IRREGULARITIES,

    HOW_PRODUCT_SETUP,
    SELECT_MOST_APPROPRIATE_DESCRIPTION,
    DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
    WAS_SHIPPING_CARTON_DAMAGED,
    WHAT_PRODUCT_WAS_SUPPOSED,
    IF_PRODUCT_CODE_NOT,
    WAS_THE_CASE_MISSING,
    WHAT_CARRIER_DELIVERED,
    WHAT_IS_PURCHASE_ORDER_NUMBER,
    WHAT_QUANTITY_MISSING_UNITS,
    WAS_EXPIRED_PRODUCT_USE,
    ADD_PRODUCT_TO_THE_GRID,
    SAVE,
    CANCEL,
    ADD_MORE_PRODUCTS,
    REPORTER_ADDRESS,
    ATTACHMENTS,
    COPYRIGHT,
    TERMS_CONDITIONS,
    PRIVACY_POLICY,
    COOKIE_POLICY,
    FORM_SUB_TITLE,
    OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
    OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE,
    OPTION_FUNCTIONOPTIONS_CAREGIVER,
    OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
    OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
    OPTION_FUNCTIONOPTIONS_PATIENT,
    OPTION_FUNCTIONOPTIONS_OTHER,
    OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
    OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
    OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
    OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
    OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
    OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
    OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_OCCUPATIONOPTIONS_NURSE,
    OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_UNITOPTIONS_BOXES,
    OPTION_UNITOPTIONS_PALLETS,
    OPTION_UNITOPTIONS_UNITS,
    OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
    OPTION_PROBLEMOPTIONS_DAMAGE,
    OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
    OPTION_PROBLEMOPTIONS_DISCOLORED,
    OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
    OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
    OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
    OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
    OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
    OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
    OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
    OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
    OPTION_PATIENTSEXOPTIONS_FEMALE,
    OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
    OPTION_PATIENTSEXOPTIONS_MALE,
    OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
    OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
    OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
    OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
    OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
    OPTION_REPORTEDTOOPTIONS_BAXTER,
    OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
    OPTION_REPORTEDTOOPTIONS_EMA,
    OPTION_REPORTEDTOOPTIONS_FDA,
    OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
    OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
    OPTION_REPORTEDTOOPTIONS_TUV,
    OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
    OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
    OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
    OPTION_DAMAGEMINICAPOPTIONS_CARTON,
    OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
    OPTION_DAMAGEMINICAPOPTIONS_POUCH,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
    OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
    OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
    OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
    OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
    OPTION_BLOCKINGFLOWOPTIONS_KINK,
    OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
    OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
    OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
    OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
    OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
    OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
    OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
    OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
    OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
    OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
    OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
    OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
    OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
    OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
    OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING,
    OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
    OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
    OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
    OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
    OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
    OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
    OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_DESCOFISSUEOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
    OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
    OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
    OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
    OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
    OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
    OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
    OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
    OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
    OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
    OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
    NO_DESCRIBE_THE_COLOR,
    OPTION_LIQUIDSPILLEDOPTIONS_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
    OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
    OPTION_VISIBLEDEFECTSOPTIONS_CAP,
    OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
    OPTION_VISIBLEDEFECTSOPTIONS_NONE,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
    OTHER_PLEASE_SPECIFY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
    OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
    OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
    OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
    OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
    OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
    DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
    DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
    OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER,
    OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
    OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
    OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
    OPTION_LEAKCOMINGFROMOPTIONS_CAP,
    OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
    OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
    OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
    OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
    OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
    OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
    OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
    OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
    OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
    OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
    DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
    YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
    OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
    OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
    OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
    OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
    OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER,
    OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER,
    OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
    OPTION_BAGLOWEROPTIONS_PRIMARY,
    OPTION_BAGLOWEROPTIONS_SECONDARY,
    OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
    OPTION_YSITECONNECTEDOPTIONS_LOWER,
    OPTION_YSITECONNECTEDOPTIONS_UPPER,
    OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
    OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
    OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
    OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
    OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
    OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
    OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
    OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
    OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
    OPTION_LEAKOCCUROPTIONS_OTHER,
    OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
    OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
    OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
    OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
    OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
    OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
    OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
    OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
    OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
    OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
    OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
    OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
    OPTION_ALARMOPTIONS_YES_SPECIFY,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
    OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
    OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
    OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
    OPTION_COMPONENTHADISSUEOPTIONS_LINES,
    OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
    OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
    OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
    OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
    OPTION_MONTHOPTIONS_JAN,
    OPTION_MONTHOPTIONS_FEB,
    OPTION_MONTHOPTIONS_MAR,
    OPTION_MONTHOPTIONS_APR,
    OPTION_MONTHOPTIONS_MAY,
    OPTION_MONTHOPTIONS_JUN,
    OPTION_MONTHOPTIONS_JUL,
    OPTION_MONTHOPTIONS_AUG,
    OPTION_MONTHOPTIONS_SEP,
    OPTION_MONTHOPTIONS_OCT,
    OPTION_MONTHOPTIONS_NOV,
    OPTION_MONTHOPTIONS_DEC,
    OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
    OPTION_PROBLEMOPTIONS_OTHER,
    OPTION_REPORTEDTOOPTIONS_OTHER,
    OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
    OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
    OPTION_BLOCKINGFLOWOPTIONS_OTHER,
    OPTION_DESCRIBEISSUEOPTIONS_OTHER,
    OPTION_MATERIALLOCATEDOPTIONS_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
    OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
    OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_OTHER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
    OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
    OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
    OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
    OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
    OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
    OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
    OPTION_ADDANOTHERFACILITYOPTIONS_NO,
    OPTION_ADDANOTHERFACILITYOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_NO,
    OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
    OPTION_PATIENINVOLVEMENTOPTIONS_YES,
    OPTION_OTHERFACILITYREPORTOPTIONS_NO,
    OPTION_OTHERFACILITYREPORTOPTIONS_YES,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
    OPTION_AVAILABILITYOPTIONS_NO,
    OPTION_AVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYOPTIONS_NO,
    OPTION_MEDIAAVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
    OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
    OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
    OPTION_COUNTERACTIONOPTIONS_NO,
    OPTION_COUNTERACTIONOPTIONS_YES,
    OPTION_DRUGUSEDOPTIONS_NO,
    OPTION_DRUGUSEDOPTIONS_YES,
    OPTION_SHARECONTACTOPTIONS_NO,
    OPTION_SHARECONTACTOPTIONS_YES,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
    OPTION_DIRECTORDEROPTIONS_NO,
    OPTION_DIRECTORDEROPTIONS_YES,
    OPTION_EXCESSIVEFORCEOPTIONS_NO,
    OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
    OPTION_EXCESSIVEFORCEOPTIONS_YES,
    OPTION_TWISTCLAMPOPTIONS_NO,
    OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TWISTCLAMPOPTIONS_YES,
    OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
    OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_NO,
    OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_YES,
    OPTION_SPONGEVISIBLEOPTIONS_NO,
    OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
    OPTION_SPONGEVISIBLEOPTIONS_YES,
    OPTION_MATERIALEMBEDDEDOPTIONS_NO,
    OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_MATERIALEMBEDDEDOPTIONS_YES,
    OPTION_PIECESMATERIALOPTIONS_NO,
    OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
    OPTION_PIECESMATERIALOPTIONS_YES,
    OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
    OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
    OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
    OPTION_INITIALCONNECTIONOPTIONS_NO,
    OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
    OPTION_INITIALCONNECTIONOPTIONS_YES,
    OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
    OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
    OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
    OPTION_PETSORANIMALSOPTIONS_NO,
    OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
    OPTION_PETSORANIMALSOPTIONS_YES,
    OPTION_MINICAPTWISTEDOPTIONS_NO,
    OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
    OPTION_MINICAPTWISTEDOPTIONS_YES,
    OPTION_TRANSFERSETOPTIONS_NO,
    OPTION_TRANSFERSETOPTIONS_UNKNOWN,
    OPTION_TRANSFERSETOPTIONS_YES,
    OPTION_RESIDUETHREADSOPTIONS_NO,
    OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_NO,
    OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_YES,
    OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
    OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
    OPTION_ADAPTERDEVICEOPTIONS_NO,
    OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
    OPTION_ADAPTERDEVICEOPTIONS_YES,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
    OPTION_FORTHMOTIONOPTIONS_NO,
    OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
    OPTION_FORTHMOTIONOPTIONS_YES,
    OPTION_ALARMNOFLOWOPTIONS_NO,
    OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
    OPTION_ALARMNOFLOWOPTIONS_YES,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
    OPTION_BROKENACTIVATEDOPTIONS_NO,
    OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
    OPTION_BROKENACTIVATEDOPTIONS_YES,
    OPTION_vaporizerSightGlassOptions_NO,
    OPTION_vaporizerSightGlassOptions_UNKNOWN,
    OPTION_vaporizerSightGlassOptions_YES,
    OPTION_PRODUCTHEATOPTIONS_NO,
    OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
    OPTION_PRODUCTHEATOPTIONS_YES,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
    OPTION_LEAKOBSERVEDOPTIONS_NO,
    OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
    OPTION_LEAKOBSERVEDOPTIONS_YES,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
    OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
    OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
    OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
    OPTION_AGITATEUNITOPTIONS_NO,
    OPTION_AGITATEUNITOPTIONS_UNKNOWN,
    OPTION_AGITATEUNITOPTIONS_YES,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
    OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
    OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
    OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
    OPTION_EXPIREDPRODUCTOPTIONS_NO,
    OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTOPTIONS_YES,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
    OPTION_BARCODESCANNEROPTIONS_NO,
    OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
    OPTION_BARCODESCANNEROPTIONS_YES,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
    OPTION_FRANGIBLEBROKENOPTIONS_NO,
    OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEBROKENOPTIONS_YES,
    OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
    OPTION_MOISTURECLEAROPTIONS_YES,
    OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
    OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
    OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
    OPTION_PRESSURECUFFOPTIONS_NO,
    OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
    OPTION_PRESSURECUFFOPTIONS_YES,
    OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
    OPTION_ADDINGMEDICATIONOPTIONS_NO,
    OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
    OPTION_ADDINGMEDICATIONOPTIONS_YES,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
    OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
    OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
    OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
    OPTION_WASPOWERINJECTOROPTIONS_NO,
    OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
    OPTION_WASPOWERINJECTOROPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
    OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
    OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
    OPTION_TOOLUSEDASSISTOPTIONS_NO,
    OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_NO,
    OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_YES,
    OPTION_PRIORDISCONNECTINGOPTIONS_NO,
    OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
    OPTION_PRIORDISCONNECTINGOPTIONS_YES,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
    OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
    OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
    OPTION_WITHPUMPOPTIONS_NO,
    OPTION_WITHPUMPOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_NO,
    OPTION_CLAMPFAILOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_YES,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
    OPTION_GELPACKSOPTIONS_NO,
    OPTION_GELPACKSOPTIONS_YES,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
    OPTION_ALARMOPTIONS_NO,
    OPTION_ALARMOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
    OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_NO,
    OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_YES,
    OPTION_FULLYTIGHTENEDOPTIONS_NO,
    OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
    OPTION_FULLYTIGHTENEDOPTIONS_YES,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_NO,
    OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_YES,
    OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
    OPTION_EXPLICITLYREQUESTOPTIONS_NO,
    OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
    OPTION_EXPLICITLYREQUESTOPTIONS_YES,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
    OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
    OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
    OPTION_HANGERUSEDOPTIONS_UNKNOWN,
    OPTION_HANGERUSEDOPTIONS_NONE,
    OPTION_BAGLOWEROPTIONS_UNKNOWN,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
    OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
    OPTION_WEIGHTUNITOPTIONS_POUND,
    OPTION_INFUSATESOLUTIONOPTIONS_NO,
    OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
    PLEASE_ENTER_THE_VALUE,
    PLEASE_SELECT_THE_VALUE,
    PLEASE_SELECT_THE_DATE,
    PLEASE_CHOOSE_THE_VALUE,
    OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
    OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
    OPTION_COUNTRYOPTIONS_KOSOVO,
    OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
    OPTION_COUNTRYOPTIONS_AFGHANISTAN,
    OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
    OPTION_COUNTRYOPTIONS_ALBANIA,
    OPTION_COUNTRYOPTIONS_ALGERIA,
    OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
    OPTION_COUNTRYOPTIONS_ANDORRA,
    OPTION_COUNTRYOPTIONS_ANGOLA,
    OPTION_COUNTRYOPTIONS_ANGUILLA,
    OPTION_COUNTRYOPTIONS_ANTARCTICA,
    OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
    OPTION_COUNTRYOPTIONS_ARGENTINA,
    OPTION_COUNTRYOPTIONS_ARMENIA,
    OPTION_COUNTRYOPTIONS_ARUBA,
    OPTION_COUNTRYOPTIONS_AUSTRALIA,
    OPTION_COUNTRYOPTIONS_AUSTRIA,
    OPTION_COUNTRYOPTIONS_AZERBAIJAN,
    OPTION_COUNTRYOPTIONS_BAHAMAS,
    OPTION_COUNTRYOPTIONS_BAHRAIN,
    OPTION_COUNTRYOPTIONS_BANGLADESH,
    OPTION_COUNTRYOPTIONS_BARBADOS,
    OPTION_COUNTRYOPTIONS_BELARUS,
    OPTION_COUNTRYOPTIONS_BELGIUM,
    OPTION_COUNTRYOPTIONS_BELIZE,
    OPTION_COUNTRYOPTIONS_BENIN,
    OPTION_COUNTRYOPTIONS_BERMUDA,
    OPTION_COUNTRYOPTIONS_BHUTAN,
    OPTION_COUNTRYOPTIONS_BOLIVIA,
    OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
    OPTION_COUNTRYOPTIONS_BOTSWANA,
    OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
    OPTION_COUNTRYOPTIONS_BRAZIL,
    OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
    OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
    OPTION_COUNTRYOPTIONS_BULGARIA,
    OPTION_COUNTRYOPTIONS_BURKINA_FASO,
    OPTION_COUNTRYOPTIONS_BURUNDI,
    OPTION_COUNTRYOPTIONS_CAMBODIA,
    OPTION_COUNTRYOPTIONS_CAMEROON,
    OPTION_COUNTRYOPTIONS_CANADA,
    OPTION_COUNTRYOPTIONS_CAPE_VERDE,
    OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
    OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_CHAD,
    OPTION_COUNTRYOPTIONS_CHILE,
    OPTION_COUNTRYOPTIONS_CHINA,
    OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
    OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
    OPTION_COUNTRYOPTIONS_COLOMBIA,
    OPTION_COUNTRYOPTIONS_COMOROS,
    OPTION_COUNTRYOPTIONS_CONGO,
    OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
    OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
    OPTION_COUNTRYOPTIONS_COSTA_RICA,
    OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
    OPTION_COUNTRYOPTIONS_CROATIA,
    OPTION_COUNTRYOPTIONS_CUBA,
    OPTION_COUNTRYOPTIONS_CYPRUS,
    OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
    OPTION_COUNTRYOPTIONS_DENMARK,
    OPTION_COUNTRYOPTIONS_DJIBOUTI,
    OPTION_COUNTRYOPTIONS_DOMINICA,
    OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_ECUADOR,
    OPTION_COUNTRYOPTIONS_EGYPT,
    OPTION_COUNTRYOPTIONS_EL_SALVADOR,
    OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
    OPTION_COUNTRYOPTIONS_ERITREA,
    OPTION_COUNTRYOPTIONS_ESTONIA,
    OPTION_COUNTRYOPTIONS_ETHIOPIA,
    OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
    OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
    OPTION_COUNTRYOPTIONS_FIJI,
    OPTION_COUNTRYOPTIONS_FINLAND,
    OPTION_COUNTRYOPTIONS_FRANCE,
    OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
    OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
    OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
    OPTION_COUNTRYOPTIONS_GABON,
    OPTION_COUNTRYOPTIONS_GAMBIA,
    OPTION_COUNTRYOPTIONS_GEORGIA,
    OPTION_COUNTRYOPTIONS_GERMANY,
    OPTION_COUNTRYOPTIONS_GHANA,
    OPTION_COUNTRYOPTIONS_GIBRALTAR,
    OPTION_COUNTRYOPTIONS_GREECE,
    OPTION_COUNTRYOPTIONS_GREENLAND,
    OPTION_COUNTRYOPTIONS_GRENADA,
    OPTION_COUNTRYOPTIONS_GUADELOUPE,
    OPTION_COUNTRYOPTIONS_GUAM,
    OPTION_COUNTRYOPTIONS_GUATEMALA,
    OPTION_COUNTRYOPTIONS_GUERNSEY,
    OPTION_COUNTRYOPTIONS_GUINEA,
    OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
    OPTION_COUNTRYOPTIONS_GUYANA,
    OPTION_COUNTRYOPTIONS_HAITI,
    OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
    OPTION_COUNTRYOPTIONS_HONDURAS,
    OPTION_COUNTRYOPTIONS_HONG_KONG,
    OPTION_COUNTRYOPTIONS_HUNGARY,
    OPTION_COUNTRYOPTIONS_ICELAND,
    OPTION_COUNTRYOPTIONS_INDIA,
    OPTION_COUNTRYOPTIONS_INDONESIA,
    OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_IRAQ,
    OPTION_COUNTRYOPTIONS_IRELAND,
    OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
    OPTION_COUNTRYOPTIONS_ISRAEL,
    OPTION_COUNTRYOPTIONS_ITALY,
    OPTION_COUNTRYOPTIONS_JAMAICA,
    OPTION_COUNTRYOPTIONS_JAPAN,
    OPTION_COUNTRYOPTIONS_JERSEY,
    OPTION_COUNTRYOPTIONS_JORDAN,
    OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
    OPTION_COUNTRYOPTIONS_KENYA,
    OPTION_COUNTRYOPTIONS_KIRIBATI,
    OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KUWAIT,
    OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
    OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    OPTION_COUNTRYOPTIONS_LATVIA,
    OPTION_COUNTRYOPTIONS_LEBANON,
    OPTION_COUNTRYOPTIONS_LESOTHO,
    OPTION_COUNTRYOPTIONS_LIBERIA,
    OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
    OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
    OPTION_COUNTRYOPTIONS_LITHUANIA,
    OPTION_COUNTRYOPTIONS_LUXEMBOURG,
    OPTION_COUNTRYOPTIONS_MACAO,
    OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_MADAGASCAR,
    OPTION_COUNTRYOPTIONS_MALAWI,
    OPTION_COUNTRYOPTIONS_MALAYSIA,
    OPTION_COUNTRYOPTIONS_MALDIVES,
    OPTION_COUNTRYOPTIONS_MALI,
    OPTION_COUNTRYOPTIONS_MALTA,
    OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
    OPTION_COUNTRYOPTIONS_MARTINIQUE,
    OPTION_COUNTRYOPTIONS_MAURITANIA,
    OPTION_COUNTRYOPTIONS_MAURITIUS,
    OPTION_COUNTRYOPTIONS_MAYOTTE,
    OPTION_COUNTRYOPTIONS_MEXICO,
    OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
    OPTION_COUNTRYOPTIONS_MOLDOVA,
    OPTION_COUNTRYOPTIONS_MONACO,
    OPTION_COUNTRYOPTIONS_MONGOLIA,
    OPTION_COUNTRYOPTIONS_MONTENEGRO,
    OPTION_COUNTRYOPTIONS_MONTSERRAT,
    OPTION_COUNTRYOPTIONS_MOROCCO,
    OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
    OPTION_COUNTRYOPTIONS_MYANMAR,
    OPTION_COUNTRYOPTIONS_NAMIBIA,
    OPTION_COUNTRYOPTIONS_NAURU,
    OPTION_COUNTRYOPTIONS_NEPAL,
    OPTION_COUNTRYOPTIONS_NETHERLANDS,
    OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
    OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
    OPTION_COUNTRYOPTIONS_NICARAGUA,
    OPTION_COUNTRYOPTIONS_NIGER,
    OPTION_COUNTRYOPTIONS_NIGERIA,
    OPTION_COUNTRYOPTIONS_NIUE,
    OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
    OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
    OPTION_COUNTRYOPTIONS_NORWAY,
    OPTION_COUNTRYOPTIONS_OMAN,
    OPTION_COUNTRYOPTIONS_PAKISTAN,
    OPTION_COUNTRYOPTIONS_PALAU,
    OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
    OPTION_COUNTRYOPTIONS_PANAMA,
    OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
    OPTION_COUNTRYOPTIONS_PARAGUAY,
    OPTION_COUNTRYOPTIONS_PERU,
    OPTION_COUNTRYOPTIONS_PHILIPPINES,
    OPTION_COUNTRYOPTIONS_PITCAIRN,
    OPTION_COUNTRYOPTIONS_POLAND,
    OPTION_COUNTRYOPTIONS_PORTUGAL,
    OPTION_COUNTRYOPTIONS_PUERTO_RICO,
    OPTION_COUNTRYOPTIONS_QATAR,
    OPTION_COUNTRYOPTIONS_RÉUNION,
    OPTION_COUNTRYOPTIONS_ROMANIA,
    OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
    OPTION_COUNTRYOPTIONS_RWANDA,
    OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
    OPTION_COUNTRYOPTIONS_SAINT_HELENA,
    OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
    OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
    OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
    OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
    OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
    OPTION_COUNTRYOPTIONS_SAMOA,
    OPTION_COUNTRYOPTIONS_SAN_MARINO,
    OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
    OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
    OPTION_COUNTRYOPTIONS_SENEGAL,
    OPTION_COUNTRYOPTIONS_SERBIA,
    OPTION_COUNTRYOPTIONS_SEYCHELLES,
    OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
    OPTION_COUNTRYOPTIONS_SINGAPORE,
    OPTION_COUNTRYOPTIONS_SLOVAKIA,
    OPTION_COUNTRYOPTIONS_SLOVENIA,
    OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
    OPTION_COUNTRYOPTIONS_SOMALIA,
    OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
    OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    OPTION_COUNTRYOPTIONS_SPAIN,
    OPTION_COUNTRYOPTIONS_SRI_LANKA,
    OPTION_COUNTRYOPTIONS_SUDAN,
    OPTION_COUNTRYOPTIONS_SURINAME,
    OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
    OPTION_COUNTRYOPTIONS_SWAZILAND,
    OPTION_COUNTRYOPTIONS_SWEDEN,
    OPTION_COUNTRYOPTIONS_SWITZERLAND,
    OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
    OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
    OPTION_COUNTRYOPTIONS_TAJIKISTAN,
    OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_THAILAND,
    OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
    OPTION_COUNTRYOPTIONS_TOGO,
    OPTION_COUNTRYOPTIONS_TOKELAU,
    OPTION_COUNTRYOPTIONS_TONGA,
    OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
    OPTION_COUNTRYOPTIONS_TUNISIA,
    OPTION_COUNTRYOPTIONS_TURKEY,
    OPTION_COUNTRYOPTIONS_TURKMENISTAN,
    OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
    OPTION_COUNTRYOPTIONS_TUVALU,
    OPTION_COUNTRYOPTIONS_UGANDA,
    OPTION_COUNTRYOPTIONS_UKRAINE,
    OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
    OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
    OPTION_COUNTRYOPTIONS_UNITED_STATES,
    OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    OPTION_COUNTRYOPTIONS_URUGUAY,
    OPTION_COUNTRYOPTIONS_UZBEKISTAN,
    OPTION_COUNTRYOPTIONS_VANUATU,
    OPTION_COUNTRYOPTIONS_VENEZUELA,
    OPTION_COUNTRYOPTIONS_VIET_NAM,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
    OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
    OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
    OPTION_COUNTRYOPTIONS_YEMEN,
    OPTION_COUNTRYOPTIONS_ZAMBIA,
    OPTION_COUNTRYOPTIONS_ZIMBABWE,
    LANDING_TERMS_I_HAVE_READ,
    LANDING_TERMS_THE_USE_DISCLOSURE,
    LANDING_TERMS_THE_TRANSFER_OF,
    LANDING_TERMS_I_UNDERSTAND_THAT,
    OPTION_DOESTHEPARTICULATEMATTER_NO,
    OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
    OPTION_DOESTHEPARTICULATEMATTER_YES,
    I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
    PRODUCT_LOT,
    SHIPPING_DISTRIBUTION_LABEL,
    CARTON_LABEL,
    INTERNAL_PRODUCT_LABEL,

    TITLE_PD_RENAL,
    TITLE_SOLUTIONS,
    TITLE_ACCESS,
    TITLE_ALL_OTHER_PRODUCT,
    REPORTED_PROBLEM,
    LOGIN,
    SYSTEM_MENU,
    INITIATE_PRODUCT_FEEDBACK,
    FEEDBACK_STATUS,
    OKTACALLBACK,
    VALID_EMAIL,
    VALID_NUMERIC,
    PLEASE_UPLOAD_IMAGE,
    VALID_DATE,
    QUANTITY,
    EDIT,
    DELETE,
    LOT_SERIAL_NO,
    LOT_NUMBER_NOT_FOUND,
    SEARCHING_LOT_NUMBER,
    PRODUCT_CODE_NOT_FOUND,
    SEARCHING_PRODUCT_CODE,
    FILE_OF_TYPES_ARE_NOT_ALLOWED,
    THE_FILE_YOU_ARE_ATTEMPTING,
    IMAGE_ICON,
    LOGIN_TO_ACCOUNT,
    SIGN_IN_TO_YOUR_ACCOUNT,
    BAXTER_EMAIL_ADDRESS,
    PASSWORD,
    SIGN_IN,
    UNKNOWN,
    ASKED_UNKNOWN,
    DD_MMM_YYYY,
    DD,
    MMM,
    YYYY,
    SELECT_COUNTRY,
    CHINESE_SIMPLIFIED_CHINESE,
    DUTCH,
    ENGLISH,
    FRENCH,
    GERMAN,
    ITALIAN,
    JAPANESE,
    KOREAN,
    MANDARIN_TRADITIONAL_CHINESE,
    POLISH,
    PORTUGUESE,
    SPANISH,
    THAI,
    TURKISH,
    VIETNAMESE,
    BROWSE,
    FEEDBACK_SUBMITTED,
    YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
    IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
    CLOSE,
    PATIENT_AGE,
    ENTER_AGE,
    PATIENT_DOB,
    RELEVANT_ATTACHMENTS,
    BAXTER_ACCOUNT_CREDENTIALS,
    GET_PRODUCT_DETAILS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_2,
    FACILITY_ADDRESS,
    LABEL_ANOTHER_FACILITY_ADDRESS,
    CHOOSE_PRODUCT_CODE,
    PRIVACY_NOTICE,
    DECLINE,
    OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
    OPTION_COUNTRYOPTIONS_CURAÇAO,
    OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
    OPTION_COUNTRYOPTIONS_ESWATINI,
    FORM_HELP_TEXT,
    YOUR_FIRST_NAME,
    YOUR_LAST_NAME,
    MY_FIRST_NAME,
    MY_LAST_NAME,
    PATIENT_FIRST_NAME,
    PATIENT_LAST_NAME,
    REPORTER_FIRST_NAME,
    REPORTER_LAST_NAME,
    EMPLOYEE_FIRST_NAME,
    EMPLOYEE_LAST_NAME,
    END_USER_CUSTOMER_FIRST_NAME,
    END_USER_CUSTOMER_LAST_NAME,
    ADDITIONAL_CONTACT_FIRST_NAME,
    ADDITIONAL_CONTACT_LAST_NAME,
    COPYRIGHT_BAXTER,
    COPYRIGHT_VERSION,
    ADD_ADDITIONAL_CONTACT,
    CONTACT_ME,
    DO_NOT_CONTACT,
    END_USER_CUSTOMER_FACILITY_NAME,
    END_USER_CUSTOMER_PHONE,
    END_USER_CUSTOMER_EMAIL,
    END_USER_CUSTOMER_FACILITY_ADDRESS,
    SAME_AS_PATIENT_ADDRESS,
    SAME_AS_REPORTER_ADDRESS,
    SAME_AS_END_USER_CUSTOMER_ADDRESS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_3,
    CONTACT_US,
    LANDING_BRIEF_FOR_DEVICE,
    PATIENT_SEX,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
    ATTENTION_NEEDED,
    SUBMIT_ERR_MSG,
    SUBMIT_RETRY_MSG,
    OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Produktrückmeldungsportal";
translations[LANDING_BRIEF] = "Das Online-Baxter Produktrückmeldungsportal ist für die Übermittlung vertraulicher Informationen und Rückmeldungen zu Baxter-Produkten vorgesehen.";
translations[LANDING_LANGUAGE_SELECTOR] = "Wählen Sie die Spracheinstellung";
translations[LANDING_COUNTRY_SELECTOR] = "Wählen Sie das Land des Ereignisses aus";
translations[LANDING_TERMS] = "Ich habe die Nutzungsbedingungen und Datenschutzbestimmungen für das Online-Baxter Produktrückmeldungsportal gelesen und stimme diesen zu.";
translations[LANDING_TERMS_ERROR] = "Sie müssen den Inhalt der Nutzungsbedingungen, der Datenschutzerklärung und der ergänzenden Nutzungsbedingungen und der Datenschutzerklärung des Online-Baxter Produktrückmeldungsportals lesen und ihnen zustimmen.";
translations[LANDING_CAPTCHA_ERROR] = "Bitte bestätigen Sie, dass Sie kein Roboter sind.";
translations[APP_DESCRIPTION] = "Das Online-Baxter Produktrückmeldungsportal ist für die Übermittlung von Informationen über Produkte vorgesehen. Wenn Sie in Problem mit einem Baxter-Produkt identifiziert haben, empfehlen wir Ihnen, die Details dieses Ereignisses mitzuteilen. Alle Rückmeldungen sind für uns unerlässlich, um unsere gemeinsamen Ziele zu erreichen und um das Produkt sowie die Zufriedenheit kontinuierlich zu verbessern.";
translations[LANDING_TERMS_I_HAVE_READ] = "Ich habe die verlinkte Datenschutzerklärung für das Baxter Produkt-Feedback-Portal gelesen und verstehe, dass die Baxter Healthcare Corporation („Baxter“) meine Zustimmung zur Verwendung, Offenlegung und Verarbeitung meiner personenbezogenen Daten für die in der Datenschutzerklärung beschriebenen Zwecke einholt. Hiermit stimme ich zu:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "Die Verwendung, Offenlegung, Speicherung und Verarbeitung meiner personenbezogenen Daten (einschließlich sensibler Daten, wie gesundheitsbezogene Daten, die ich freiwillig zur Verfügung stelle) für die in der Datenschutzerklärung genannten Zwecke.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "Die Übertragung meiner personenbezogenen Daten (einschließlich sensibler Daten, wie gesundheitsbezogene Daten, die ich freiwillig zur Verfügung stelle) aus meinem Land und in ein anderes Land, in dem möglicherweise weniger strenge oder keine Datenschutzgesetze gelten.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Ich verstehe, dass diese Einwilligung freiwillig ist und dass ich meine Meinung jederzeit ändern und meine Zustimmung widerrufen kann, indem ich mich über die in der Datenschutzerklärung angegebenen Kontaktdaten an Baxter wende. Ich verstehe, dass der Widerruf meiner Einwilligung die Rechtmäßigkeit der Verarbeitung vor dem Widerruf nicht beeinträchtigt.";
translations[MENU_FEEDBACK_FORM] = "Initiere Produktrückmeldung";
translations[MENU_FEEDBACK_STATUS] = "Produktrückmeldung-Status prüfen";
translations[MENU_FORM_INTAKE] = "Reporter/Kontaktinformationen";
translations[MENU_FORM_EVENT_DETAILS] = "Einzelheiten des Ereignisses";
translations[MENU_FORM_PRODUCT_INFO] = "Produktinformationen";
translations[SYSTEM_FEEDBACK_FORM] = "Initiere Produktrückmeldung-Formular";
translations[SYSTEM_FEEDBACK_STATUS] = "Produktrückmeldung-Status prüfen";
translations[SUBMIT_FEEDBACK] = "Klicken Sie hier, um die Rückmeldung einzureichen.";
translations[CHECK_SUBMITTED_FEEDBACK] = "Klicken Sie hier, um den Status des zuvor übermittelten Rückmeldung zu prüfen";
translations[BTN_LAUNCH_FORM] = "Formular starten";
translations[BTN_CHECK_STATUS] = "Status prüfen";
translations[FORM_TITLE] = "Formblatt Produktrückmeldung";
translations[FORM_SUB_TITLE] = "Wenn mehrere Patienten involviert sind, füllen Sie bitte für jeden Patienten ein Formblatt aus.";
translations[FORM_MANDATORY_FIELDS] = "Alle Felder mit * sind Pflichtfelder";
translations[BUTTON_PREV] = "Vorherige";
translations[BUTTON_NEXT] = "Nächste";
translations[BUTTON_SUBMIT] = "Einreichen";
translations[SELECT_RESPONSE] = "Antwort wählen";
translations[FUNCTION_ROLE] = "Funktion/Rolle";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Kundennummer";
translations[ENTER_CUSTOMER_ACCOUNT] = "Kundenkonto eingeben";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "Wie lautet die Kundennummer, der an dem gemeldeten Ereignis beteiligt ist?";
translations[EVENT_REPORTED] = "Wurde dieses Ereignis zuvor gemeldet (an Baxter oder ein anderes Unternehmen)?";
translations[REFERENCE_NUMBER] = "Referenznummer, die mit diesem Ereignis verknüpft ist";
translations[ENTER_REFERENCE] = "Referenz eingeben";
translations[WHO_REPORTED_TO] = "Wem wurde das gemeldet?";
translations[WHO_WAS_NOTIFIED] = "Geben Sie den Namen an, wer benachrichtigt wurde?";
translations[ENTER_NAME] = "Geben Sie den Namen ein";
translations[PRODUCT_SURVEILLANCE] = "Kann die Produktüberwachung/Baxter Sie oder eine andere Person kontaktieren, wenn wir weitere Fragen haben?";
translations[YOUR_NAME] = "Ihr Name";
translations[OCCUPATION] = "Beruf";
translations[PHONE_NUMBER] = "Telefonnummer";
translations[ENTER_PHONE_NUMBER] = "Geben Sie die Telefonnummer ein";
translations[ENTER_EMAIL] = "Geben Sie die E-Mail ein";
translations[EMAIL_ADDRESS] = "Email-Adresse";
translations[ENTER_ADDRESS] = "Geben Sie die E-Mail-Adresse ein";
translations[ENTER_NA_IF_UNKNOWN] = "Geben Sie NA ein, wenn dies unbekannt ist";
translations[FACILITY_HOSPITAL] = "Name der Einrichtung, des Krankenhauses oder des Vertriebspartners (falls zutreffend)";
translations[ENTER_FACILITY] = "Geben Sie die Einrichtung ein";
translations[ADDRESS_1] = "Adresse 1";
translations[ADDRESS_2] = "Adresse 2";
translations[CITY] = "Stadt";
translations[STATE] = "Bundesland";
translations[POSTAL_CODE] = "Postleitzahl";
translations[COUNTRY] = "Land";
translations[END_USER_CUSTOMER] = "Wurde dieses Problem von einem Endbenutzer/Kunden entdeckt?";
translations[ADDITIONAL_CONTACT_PERSON] = "Zusätzlicher Ansprechpartner";
translations[ADDITIONAL_PHONE] = "Zusätzliche Telefonnummer des Kontakts";
translations[ADDITIONAL_EMAIL] = "Zusätzliche E-Mail des Kontakts";
translations[ANOTHER_FACILITY_ADDRESS] = "Füge eine weitere Einrichtung/Adresse hinzu";
translations[ANOTHER_FACILITY_HOSPITAL] = "Name einer anderen Einrichtung, eines Krankenhauses oder eines Händlers (falls zutreffend)";
translations[ANOTHER_ENTER_FACILITY] = "Geben Sie die Einrichtung ein";
translations[ANOTHER_ADDRESS_1] = "Adresse 1";
translations[ANOTHER_ADDRESS_2] = "Adresse 2";
translations[ANOTHER_CITY] = "Stadt";
translations[ANOTHER_STATE] = "Bundesland";
translations[ANOTHER_POSTAL_CODE] = "Postleitzahl";
translations[ANOTHER_COUNTRY] = "Land";
translations[LOT_SERIAL_NUMBER] = "Chargennummer/Seriennummer";
translations[ENTER_LOT_SERIAL_NUMBER] = "Geben Sie Chargennummer/Seriennummer ein";
translations[HELP_LOT_SERIAL_NUMBER] = "Geben Sie 'Unbekannt' ein, wenn Sie die Charge(n)/Seriennummer(n) nicht kennen, oder 'Angefragt, aber unbekannt', wenn Sie den Reporter gefragt haben und er es nicht wusste.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Artikelnummer";
translations[PRODUCT_CODE] = "Artikelnummer";
translations[ENTER_PRODUCT_CODE] = "Geben Sie die Artikelnummer ein";
translations[HELP_PRODUCT_CODE] = "Geben Sie 'Unbekannt' ein, wenn Sie die Artikelnummer(n) nicht kennen, oder 'Angefragt, aber unbekannt', wenn Sie den Reporter gefragt haben und er es nicht wusste.";
translations[NDC] = "Nummer des nationalen Arzneimittelcodes (NDC)";
translations[ENTER_NDC] = "Geben Sie die NDC ein";
translations[UDI] = "Eindeutige Gerätekennung (UDI)";
translations[ENTER_UDI] = "Geben Sie die UDI ein";
translations[PRODUCT_NAME] = "Name des Produkts";
translations[ENTER_PRODUCT_NAME] = "Geben Sie den Produktnamen ein";
translations[HELP_PRODUCT_NAME] = "Geben Sie den Namen oder die Beschreibung des Produkts an";
translations[BEST_DESCRIBES] = "Bitte treffen Sie eine Auswahl, die das gemeldete Problem am besten beschreibt";
translations[QUANTITY_TO_SELECT] = "Zu wählende Menge";
translations[ENTER_QUANTITY] = "Geben Sie die Menge ein";
translations[HELP_QUANTITY] = "Anzahl des Produkts mit dem gemeldeten Problem";
translations[UNIT] = "Einheit";
translations[AVAILABLE_TO_RETURNED] = "Kann das eigentliche Produkt mit dem gemeldeten Problem zur Bewertung an Baxter zurückgegeben werden?";
translations[PHOTOGRAPH_AVAILABLE] = "Ist ein Foto oder Video des Produkts verfügbar?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Stellen Sie sicher, dass das gemeldete Problem auf dem Foto oder Video sichtbar ist.";
translations[UPLOAD_IMAGES] = "Bilder hochladen";
translations[REPORTER_NAME] = "Name des Melders";
translations[REPORTER_FACILITY] = "Einrichtung des Melders";
translations[REPORTER_OCCUPATION] = "Beruf des Melders";
translations[ENTER_NUMBER] = "Geben Sie Nummer ein";
translations[REPORTER_PHONE_NUMBER] = "Telefonnummer des Melders";
translations[REPORTER_EMAIL_ADDRESS] = "E-Mail Adresse des Melders";
translations[EMPLOYEE_NAME] = "Name des Mitarbeiters";
translations[EMPLOYEE_PHONE_NUMBER] = "Telefonnummer des Mitarbeiters";
translations[EMPLOYEE_EMAIL_ADDRESS] = "E-Mail-Adresse des Mitarbeiters";
translations[RETURNING_FOR_INVESTIGATION] = "Wie viele Muster (in Einheiten) mit dem gemeldeten Problem senden Sie zur Untersuchung zurück?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Diese Muster sollten die Produkte mit dem gemeldeten Problem sein.";
translations[UNUSED_BAXTER_PRODUCT] = "Gibt es EIN unbenutztes Baxter-Produkt aus derselben Charge, das zur Bewertung an Baxter zurückgegeben werden kann?";
translations[YOU_INDICATED_SAMPLES] = "Sie haben angegeben, das Muster zur Verfügung stehen. Können Sie diese zu Ihren Gesundheitsdienstleister bringen?";
translations[SAMPLE_RETURN_KIT] = "Sie haben angegeben, das Muster zur Bewertung verfügbar wären. Bitte bestätigen Sie die angegebene Adresse, um das Musterrücksendekit zu senden:";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "An diese Adresse wird ein Karton mit einem vorfrankierten Etikett gesendet, um das Muster zurückzusenden";
translations[SAME_AS_MY_ADDRESS] = "Gleiche Adresse wie meine";
translations[OTHER_CONTACT_NAME] = "Name des anderen Kontakts";
translations[OTHER_CONTACT_OCCUPATION] = "Beruf des anderen Kontakts";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Telefonnummer des anderen Kontakts";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "E-Mail-Adresse des anderen Kontakts";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "Das von Ihnen ausgewählte Produkt wird von einem anderen Unternehmen hergestellt. Können wir ihnen Ihre Kontaktinformationen zur Verfügung stellen, wenn sie weitere Fragen zu Ihrem Bericht haben?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "Hat der Kunde explizit Untersuchungsergebnisse angefordert?";
translations[EXPLICITLY_REQUEST_CREDIT] = "Hat der Kunde ausdrücklich eine Gutschrift angefordert?";
translations[PRODUCT_FROM_BAXTER] = "Bestellt der Kunde das Produkt direkt bei Baxter?";
translations[QUANTITY_REQUESTED_CREDIT] = "Chargennummer (n) und Menge, die für die Gutschrift angefordert wird:";
translations[ENTER_OCCUPATION] = "Geben Sie den Beruf ein";
translations[LOT_QUANTITY_NUMBER] = "Geben Sie Chargennummer und Menge ein";
translations[WHOLESALERS_NAME] = "Wie lautet der Name und Standort des Großhändlers (Stadt, Bundesland)";
translations[PLACE_WHOLESALERS_NAME] = "Wie lautet der Name und Standort des Großhändlers (Stadt, Bundesland)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Produkt zur Liste hinzufügen";
translations[SAVE] = "Speichern";
translations[CANCEL] = "Löschen";
translations[ADD_MORE_PRODUCTS] = "Weitere Produkte HINZUFÜGEN";
translations[REPORTER_ADDRESS] = "Adresse des Melders";
translations[ATTACHMENTS] = "Anhänge";
translations[DATE_OF_EVENT] = "Datum des Ereignisses";
translations[DATE_OF_EVENT_MSG] = "Das Datum des Ereignisses kann nicht nach dem Datum liegen, an dem ein Baxter Mitarbeiter erstmals benachrichtigt wurde. Bitte geben Sie ein gültiges Datum ein.";
translations[HELP_DATE_OF_EVENT] = "Wenn es mehrere bekannte Daten gibt, an denen das Ereignis stattgefunden hat, füllen Sie bitte jeweils ein Formular für jedes Datum aus.";
translations[DATE_BAXTER_EMPLOYEE] = "Datum, an dem Baxter Mitarbeiter zum ersten Mal benachrichtigt wurde";
translations[DATE_MESSAGE_BAXTER_EMPLOYEE] = "(Das angegebene Datum muss nicht mit dem Datum übereinstimmen, an dem die Informationen eingegeben wurden.)";
translations[DURING_WHAT_PROCESS] = "In welchen Prozessschritten ist das Ereignis aufgetreten?";
translations[WAS_THE_PATIENT] = "War der Patient zum Zeitpunkt des Ereignisses verbunden (Behandlung im Gange)?";
translations[WERE_YOU_CONNECTED] = "Waren Sie zum Zeitpunkt des Ereignisses angeschlossen (Behandlung im Gange)?";
translations[PROVIDE_ANY_ADDITIONAL] = "Geben Sie alle zusätzlichen Details in Bezug auf das Ereignis/Problem an";
translations[HELP_YOU_IDENTIFIED_MORE] = "Sie haben mehr als ein Produkt und ein Problem identifiziert, bitte klären Sie, welche Produkte von welchen Problemen gemeldet wurden.";
translations[ENTER_DETAILS] = "Geben Sie Details ein";
translations[PROVIDE_ANY_ATTACHMENT] = "Geben Sie gegebenenfalls einen Anhang an";
translations[WAS_NEGATIVE_MEDICAL] = "Gab es negative medizinische Auswirkungen, Symptome oder Verletzungen aufgrund des Ereignisses?";
translations[WAS_MEDICAL_INTERVENTION] = "Wurde eine Behandlung, medizinische Intervention oder Eskalation der Versorgung bereitgestellt, um dem gemeldeten Ereignis entgegenzuwirken?";
translations[PROVIDE_DETAILS] = "Geben Sie Details an";
translations[REQUIRED_TREATMENT] = "Erforderliche Behandlung/medizinische Intervention";
translations[ENTER_TREATMENT] = "Geben Sie die Behandlung ein";
translations[RELEVANT_TESTS] = "Relevante Tests einschließlich Labordaten:";
translations[HELP_RELEVANT_TESTS] = "Geben Sie relevante Tests ein";
translations[RELEVANT_MEDICAL_HISTORY] = "Relevante Anamnese einschließlich bereits bestehender Erkrankungen:";
translations[ENTER_HISTORY] = "Geben Sie die Historie ein";
translations[PATIENT_NAME] = "Name des Patienten";
translations[PATIENT_INITIALS] = "Patienteninitialen oder voller Name. Wenn mehrere Patienten involviert sind, füllen Sie bitte für jeden Patienten ein eigenes Formular aus.";
translations[PATIENT_PHONE_NUMBER] = "Telefonnummer des Patienten";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "Möchte ich nicht angeben";
translations[PATIENT_EMAIL_ADDRESS] = "E-Mail-Adresse des Patienten";
translations[PATIENT_ADDRESS] = "Adresse des Patienten";
translations[SAME_ADDRESS] = "Gleiche Adresse";
translations[DRUG_BEING_USED] = "Wurde zum Zeitpunkt des Ereignisses ein Baxter-Medikament verwendet?";
translations[PATIENT_IDENTIFIER] = "Patienten-Kennung";
translations[PATIENT_AGE_OR_DOB] = "Patientenalter oder Geburtsdatum";
translations[ENTER_PATIENT_AGE] = "mm/tt/yyyy, Geben Sie das Patientenalter ein";
translations[PATIENT_GENDER] = "Geschlecht des Patienten";
translations[PATIENT_WEIGHT] = "Gewicht des Patienten";
translations[ENTER_WEIGHT] = "Geben Sie das Gewicht ein";
translations[PATIENT_WEIGHT_UNIT] = "Gewichtseinheit des Patienten";
translations[MY_NAME] = "Mein Name";
translations[ENTER_IN_YOUR_CONTACT] = "Geben Sie Ihre Kontaktinformationen ein";
translations[MY_PHONE_NUMBER] = "Meine Telefonnummer";
translations[MY_EMAIL_ADDRESS] = "Meine E-Mail Adresse";
translations[MY_ADDRESS] = "Meine Adresse";
translations[NAME_OF_BAXTER_DRUG] = "Name des Baxter Arzneimittels";
translations[ENTER_DRUG_NAME] = "Geben Sie den Arzneimittelnamen ein";
translations[PLEASE_PROVIDE_THE_NAME] = "Bitte geben Sie den Namen oder Produktcode des Baxter-Medikaments an. Geben Sie den Namen aller Baxter-Medikamente an, die zum Zeitpunkt des gemeldeten Problems verwendet wurden";
translations[SELECT_THE_COMPONENT] = "Wählen Sie die Komponente aus, die das Problem hatte";
translations[USE_THE_DIAGRAM] = "Verwenden Sie das obige Diagramm (Abbildung 1), um die Stelle des beschädigten Einweges zu bestimmen.";
translations[TYPE_OF_DAMAGE] = "Bitte beschreiben Sie die Art des Schadens";
translations[PLEASE_ENTER_VALUE] = "Bitte geben Sie den Wert ein";
translations[WAS_THE_PRODUCT_KINKED] = "Wurde das Produkt geknickt, gebrochen, gebogen, zerschnitten usw.?";
translations[WERE_ANY_CLEANING] = "Wurden Reinigungslösungen, Lösungsmittel oder Desinfektionsmittel für das Produkt verwendet?";
translations[WHAT_WAS_THE_DISINFECTANT] = "Wie lautete der Name/Marke des Desinfektionsmittels und wie wurde es verwendet?";
translations[NOTE_BAXTER_LABELING] = "Laut Baxter Labelling darf kein Bleichmittel, Wasserstoffperoxid, Alkohol oder alkoholhaltiges Antiseptikum auf das Set aufgebracht werden. Die Verwendung dieser Produkte kann dazu führen, dass das Produkt Risse entwickelt.";
translations[SELECT_ALL_THAT_APPLY] = "Alles zutreffende auswählen";
translations[DID_FOLLOWING_OCCUR] = "Ist einer der folgenden Punkte aufgetreten?";
translations[SELECT_THE_LOCATION] = "Wähle die Stelle mit dem Schaden auf dem Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "War das Produkt einer übermäßigen Kraft ausgesetzt (dh geknallt, gestoßen, geschlagen usw.), bevor das Problem auftrat?";
translations[HOW_LONG_TRANSFER] = "Wie lange wurde das Transferset verwendet?";
translations[WAS_THERE_DIFFICULTY] = "Gab es Schwierigkeiten beim Öffnen oder Schließen der Drehklemme?";
translations[WAS_DEVICE_OR_TOOL] = "Wurde ein Gerät oder Werkzeug zum Öffnen oder Schließen der Drehklemme verwendet?";
translations[DESCRIBE_HOW_PRODUCT] = "Beschreiben Sie, wie das Produkt schwierig zu verwenden war (Wählen Sie alles zutreffende aus)";
translations[DID_YOU_OBSERVE] = "Haben Sie Schäden (z. B. Schnitt, Loch, Riss) an dem Produkt festgestellt?";
translations[WERE_DIFFICULTIES_PUTTING] = "Gab es Schwierigkeiten, das Minicap auf dem Transferset anzubringen und im Uhrzeigersinn zu drehen, bis es fest gesichert ist?";
translations[WAS_THE_TRANSFER] = "Wurde das Transferset aufgrund dieses Ereignisses ersetzt?";
translations[SELECT_TYPE_OF_FLOW] = "Typ des Fluss-Problems wählen";
translations[WAS_ANYTHING_BLOCKING] = "Hat irgendetwas den Fluss blockiert?";
translations[WAS_ANY_ALARM] = "Gab es einen Alarm?";
translations[SELECT_BEST_DESCRIBE] = "Wählen Sie eine Option aus, die das Problem am besten beschreibt";
translations[WERE_THE_MINICAPS] = "Wurden die Minicaps exponiert oder in einer heißen/kalten Umgebung gelagert?";
translations[WAS_THE_SPONGE_VISIBLE] = "War der Schwamm im Minicap sichtbar?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "Wo befindet sich der Partikel/Fremdstoff?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Beschreiben Sie die genaue Lage, Größe, Form und Farbe des Partikels/Fremdmaterials:";
translations[WAS_THE_PARTICULATE_MATTER] = "War der Partikel/das Fremdmaterial in das Produkt eingebettet?";
translations[DOES_THE_PARTICULATE_MATER] = "Scheint der Partikel-/das Fremdmaterial Teile des Produktmaterials zu sein?";
translations[WHAT_COMPONENT_DOES] = "Aus welcher Komponente scheint der Partikel zu stammen?";
translations[SELECT_CONNECTION_ISSUE] = "Wählen Sie die Option aus, die das Verbindungsproblem am besten beschreibt";
translations[WERE_ASSIST_DEVICES] = "Wurden Hilfsgeräte oder Werkzeuge verwendet, um die Verbindung mit dem Set herzustellen?";
translations[WERE_ANY_DIFFICULTIES] = "Wurden Schwierigkeiten oder eine Lockerung bei der ersten Verbindung festgestellt ?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Geben Sie die Produktinformationen des zweiten Produkts an, das an dem Verbindungsproblem beteiligt war";
translations[WERE_THE_SPIKE_LUER] = "Wurden die Spike/Luer-Anschlüsse im Uhrzeigersinn gedreht, bis sie fest gesichert waren?";
translations[BAXTER_LABELING_STATES] = "Laut Baxter-Kennzeichnung muss vor Beginn der Therapie sichergestellt werden, dass Set-Verbindungen sicher und fest verbunden sind.";
translations[WERE_PETS_OR_ANIMALS] = "Gab es Haustiere oder Tiere, die das Einwegset hätten beschädigen können?";
translations[BAXTER_LABELING_CONTAMINATION] = "Die Baxter-Kennzeichnung besagt, dass eine Kontamination der Fließwege die Folge sein kann, wenn ein Haustier oder ein anderes Tier Einmalsets anbeißt. Um dieses Risiko zu verringern, führen Sie keine Dialyse im selben Raum mit Haustieren oder anderen Tiere durch.";
translations[WERE_OTHER_ISSUES] = "Gab es andere Probleme oder Schwierigkeiten im Zusammenhang mit dem Spike/Luer (d. h. gerissen, deformiert, gebogen usw.)?";
translations[WAS_MINICAP_TWISTED] = "Wurde der Minicap im Uhrzeigersinn auf den Transfer-Set-Steckverbinder gedreht, bis er fest gesichert ist?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Gab es Schwierigkeiten, das Minicap auf das Transferset zu setzen?";
translations[DID_TRANSFER_SET_CONNECTORS] = "Hatten die Transferset-Anschlüsse sichtbare Schäden oder Rückstände an den Gewinden?";
translations[WHAT_WAS_THE_ALARM] = "Was war der Alarm?";
translations[WHERE_OBSERVED_DAMAGE] = "Wo war der beobachtete Schaden (wählen Sie alles zutreffende aus)?";
translations[SELECT_THE_TYPE_OBSERVED] = "Wählen Sie den Typ des beobachteten Schadens aus (wählen Sie alle zutreffenden aus):";
translations[DID_DAMAGE_CAUSE_LEAK] = "Hat der Schaden ein Leck verursacht?";
translations[WAS_THE_SHIPPING_CARTON] = "Wurde der Versandkarton mit einem scharfen Gegenstand geöffnet?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Wählen Sie die Art des beobachteten Flussproblems";
translations[HOW_LONG_WAS_STORAGE] = "Wie lange war es gelagert, bevor das abgelaufene Produkt entdeckt wurde?";
translations[WAS_THERE_AN_ADAPTER] = "Gab es einen Adapter oder ein anderes Gerät (e), das mit dem Produkt verwendet wurde?";
translations[NAME_AND_MODEL] = "Wie lautet der Name und das Modell des Adapters oder eines anderen verwendeten Geräts?";
translations[NAME_VAPORIZER] = "Wie lautet der Name und das Modell des Vaporizers?";
translations[WAS_VIAL_INVERTED] = "Wurde die beigefügte Durchstechflasche vor dem Zusammendrücken der Lösung in die Durchstechflasche invertiert?";
translations[WHAT_VIAL_USED] = "Was sind die Produktinformationen für die verwendete Durchstechflasche?";
translations[DRUG_NAME_MANUFACTURER] = "Arzneimittelname, Hersteller, Größe der Durchstechflasche";
translations[WERE_BREAK_FRANGIBLE] = "Konnten Sie das Knickventil mit einer Hin- und Her-Bewegung richtig brechen?";
translations[WAS_ALARM_ASSOCIATED] = "Gab es einen Alarm im Zusammenhang mit blockierten Fluss?";
translations[WHAT_PART_DISCOLORED] = "Welcher Teil des Produkts wurde berichtet, dass er verfärbt war? (wählen Sie alles zutreffende aus)";
translations[DESCRIBE_DISCOLORATION] = "Beschreiben Sie die Verfärbung (beschreiben Sie Farbe,  Farbton, Schatten usw.):";
translations[HOW_PRODUCT_STORED] = "Wie wurde das Produkt gelagert?";
translations[DOES_DISCOLORATION_APPEAR] = "Scheint die Verfärbung undurchsichtig, trüb, und/oder hat wabenförmige Markierungen?";
translations[WHICH_CHAMBER_DISCOLORED] = "Welche Kammer des Beutels war verfärbt?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "War die Schweißnaht oder das Knickvemtil bereits zerbrochen/aktiviert?";
translations[WAS_DISCOLORATION_NOTICED] = "Wurde die Verfärbung durch das Vaporizer-Schauglas bemerkt?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Wählen Sie eine Option aus, die das Problem genauer beschreibt:";
translations[WHAT_DEVICE_HAD_ALARM] = "Welches Gerät hatte den Alarm?";
translations[WHAT_MISSING_MISASSEMBLED] = "Welche Komponente fehlte oder wurde falsch zusammengebaut?";
translations[RECONSTITUTION_ISSUE] = "Geben Sie eine genauere Beschreibung des Problems bei der Rekonstitution an";
translations[WHAT_MEDICATION_SOLUTION] = "Mit welcher Arzneimittel/Lösung wurde das Produkt rekonstituiert?";
translations[WHAT_VOLUME_MEDICATION] = "Wie groß war das Volumen der Arzneimittel/Lösung, die zur Rekonstituation verwendet wurde?";
translations[WHAT_DEVICES_RECONSTITUTION] = "Welche anderen Geräte wurden während der Rekonstitution verwendet (Name/Hersteller, Nadelgröße/Nadeldurchmesser etc usw.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "War das Produkt Hitze ausgesetzt?";
translations[DESCRIBE_EXPOSURE] = "Beschreiben Sie die Exposition (Temperatur, wie lange usw.)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "Welche Technik wurde verwendet, um die Lösung zu aktivieren?";
translations[WAS_DAMAGE_OBSERVED] = "Wurden vor der Aktivierung Schäden am Produkt festgestellt?";
translations[DESCRIBE_THE_DAMAGE] = "Beschreibe den Schaden:";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Wie viel Lösung oder Pulver war ungefähr untergefüllt oder überfüllt?";
translations[WAS_LEAK_OBSERVED] = "Wurde ein Leck beobachtet?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "Welche Komponente oder welches Merkmal des Produkts ist schwer zu verwenden?";
translations[HOW_WAS_DIFFICULT_USE] = "Wie war das Produkt schwierig zu verwenden?";
translations[WHERE_MATTER_FOREIGN] = "Wo befand sich der Partikell/das Fremdmaterial?";
translations[DOES_PARTICULATE_MATTER] = "Scheint der Partikel/das Fremdmaterial Teil des Produktmaterials zu sein?";
translations[DESCRIBE_EXACT_LOCATION] = "Beschreiben Sie die genaue Stelle, die Farbe, die Größe, die Form und die Textur des Partikelstoffs/des Fremdmaterials:";
translations[WAS_MATTER_FOREIGN] = "War der Partikel/das Fremdmaterial in das Produkt eingebettet (nicht frei beweglich)?";
translations[WHEN_MATTER_FOREIGN] = "Wann wurde der Partikel/das Fremdmaterial beobachtet?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Geben Sie Produktinformationen für das hinzugefügte Medikament an:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Produktname, Produktcode, Charge, Markenname";
translations[DESCRIBE_SPIKING] = "Beschreiben Sie die verwendete Spiking- oder Rekonstitutionstechnik:";
translations[INCLUDE_NEEDLE] = "Nadelgröße und - durchmesser, Nadel-/einstechwinkel, Anzahl der Versuche angeben";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "Welches Administrationsset oder Rekonstitutionsgerät wurde verwendet?";
translations[INCLUDE_MANUFACTURER] = "Hersteller, Produktname, Produktcode, Charge angeben";
translations[WAS_MEDICATION_ADDITIVE] = "Wurde dem Produkt eine Medikament-, Zusatzstoff- oder Rekonstitutionslösung hinzugefügt?";
translations[WHAT_MEDICATION_ADDITIVE] = "Welche Medikamente-, Additiv- oder Rekonstitutionslösung wurde hinzugefügt?";
translations[WHAT_STATE_OF_PRODUCT] = "Wie war der Zustand des Produkts, als die Trübung/der Niederschlag beobachtet wurde?";
translations[AFTER_UNITS_SAT] = "Nachdem die Teilchen sich gesetzt und Raumtemperatur erreicht hatten, ist die Trübung/der Niederschlag verschwunden?";
translations[DID_ATTEMPT_AGITATE] = "Hast du versucht, umzurühren?";
translations[DID_PRECIPITATE_DISSOLVE] = "Hat sich der Niederschlag aufgelöst?";
translations[WHAT_STORAGE_TEMPERATURE] = "Wie lauteten die Lagertemperatur und die -bedingungen des Produkts?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Geben Sie Temperatur, Lagerungsort, Lagerungsart ( ob innerhalb oder außerhalb des Umbeutels/Kartons, oder als einzelne Einheiten) an";
translations[ARE_TEMPERATURE_LOGS] = "Sind Temperaturprotokolle für die Gefriertruhe(n) verfügbar, in denen das Produkt gelagert wird?";
translations[LOGS_CAN_BE_ATTACHED] = "Protokolle können direkt an dieses Formular angehängt werden, sofern sie zum Zeitpunkt der Einreichung verfügbar sind";
translations[IS_THE_STORAGE_UNIT] = "Ist das Lager (Gefrierschrank oder Kühlschrank) kalibriert und temperaturkontrolliert?";
translations[HOW_PRODUCT_THAWED] = "Wie wurde das Produkt aufgetaut?";
translations[WHAT_STORAGE_CONDITIONS] = "Wie waren die Lagerbedingungen des Produkts? (Temperatur, Standort, innerhalb oder außerhalb des Umrbeutel/Kartons gelagert)";
translations[WAS_ANY_DAMAGE] = "Wurden Schäden am Produkt oder anderweitige Probleme beobachtet?";
translations[MORE_SPECIFIC_INFORMATION] = "Bitte geben Sie genauere Informationen an:";
translations[WHAT_PURPOSE_INDICATION] = "Was war der Zweck/die Indikation einer Behandlung für den Patienten?";
translations[WHAT_ROUTE_ADMINISTRATION] = "Wie wurde verabreicht?";
translations[WHAT_DATE_ADMINISTRATION] = "Was war das Datum der Verabreichung und deren Dauer?";
translations[WHAT_DOSAGE_STRENGTH] = "Welche Dosierung/Stärke wurde dem Patienten verabreicht?";
translations[WAS_RECENT_PRESCRIPTION] = "Gab es kürzlich eine Änderung der Verschreibung?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "Wie lauteten die Lager-/Temperaturangaben des Produkts (Lagerstandort/Kühlschrank/Gefrierschrank usw.)?";
translations[WERE_ANY_ADJUSTMENTS] = "Gab es vor der Verabreichung Anpassungen der Lösung oder der Zusätze?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Wählen Sie die am besten geeignete Beschreibung des Problems aus:";
translations[SELECT_LABELING_ISSUE] = "Wählen Sie die am besten geeignete Beschreibung des Kennzeichnungsproblems aus:";
translations[WAS_CONNECTION_SECURE] = "War die Verbindung sicher und vollständig festgezogen?";
translations[WAS_EXPIRED_PRODUCT] = "Wurde das abgelaufene Produkt einem Patienten verabreicht?";
translations[WAS_COMPONENT_DAMAGED] = "Wurde eine Komponente beschädigt?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Wurden Anomalitien/Schäden am Produkt festgestellt?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "Wie lautet Ihre Bestellnummer?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "Wie lautete das Datum der Verabreichung?";
translations[WHAT_WAS_EXPIRATION_DATE] = "Wie lautete das Verfallsdatum des Produkts?";
translations[DESCRIBE_WAS_INCORRECT] = "Beschreiben Sie, was auf dem Etikett falsch, unvollständig, fehlend, unleserlich war oder was (einem anderen Produkt) auf dem Etikett zu ähnlich war:";
translations[WHAT_SCANNER_USED] = "Welche Art von Scanner wurde verwendet?";
translations[WAS_OVERPOUCH_POUCH] = "Befand sich das Produkt beim Scannen noch im Umbeutel/Beutel?";
translations[WHAT_BACKGROUND_COLOR] = "Wie war die Hintergrundfarbe beim Scannen?";
translations[DO_ALL_OF_THE_LABELS] = "Haben alle Etiketten (Produkt, Produkarton/Versandkarton, Versand/Vertrieb) die gleichen Produktinformationen?";
translations[PRODUCT_INFORMATION] = "Produktinformationen";
translations[IS_A_BARCODE_SCANNER] = "Wird ein Barcodescanner in Ihrer Einrichtung verwendet?";
translations[HOW_ARE_THESE_PRODUCTS] = "Wie werden diese Produkte bei Ihnen gelagert?";
translations[WHAT_INFORMATION_INCORRECTLY] = "Welche Informationen wurden beim Scannen falsch angezeigt?";
translations[WAS_THERE_LEAK] = "Wurde ein Leck oder Feuchtigkeit beobachtet?";
translations[WHERE_LEAK_OBSERVED] = "Wo wurde das Leck beobachtet, welche Komponente ist undicht?";
translations[WAS_FRANGIBLE_OBSERVED] = "War das auffällige Knickventil defekt?";
translations[IS_MOISTURE_CLEAR] = "Ist die Feuchtigkeit klar?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Wer ist Ihr Vertriebspartner?";
translations[WHAT_MANUFACTURER_MEDICATION] = "Wie lautet der Hersteller, der Name des Medikaments und die Größe der verwendeten Durchstechflasche?";
translations[WHAT_GAUGE_NEEDLE] = "Wie ist der Durchmesser der verwendeten Nadel, wer ist der Hersteller der Nadel, und wie oft wurde punktiert?";
translations[WHAT_ADMINISTRATION_SET] = "Welches Administrationsset wurde verwendet?";
translations[WAS_DIFFICULTY_SPIKING] = "Gab es Schwierigkeiten beim Anstechen?";
translations[WERE_FOLLOWING_SCENARIOS] = "War eines der folgenden Szenarien mit dem Leck aufgetreten?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "Wurde festgestellt, dass der Knickventil einen Schaden oder einen Defekt hatte?";
translations[WHAT_AMOUNT_PRESSURE] = "Welcher Druck wurde ausgeübt und für welche Dauer?";
translations[WAS_BAG_COMPLETELY] = "Wurde der Beutel vollständig und korrekt in die Druckmanschette gesteckt (war ein Ende außerhalb der Druckmanschette)?";
translations[WHAT_MANUFACTURER_MODEL] = "Was ist der Hersteller, das Modell und die Größe der Druckmanschette?";
translations[WHAT_PRESSURE_PRIOR] = "Wie hoch war der Druck vor dem Erkennen des Lecks?";
translations[LIST_THE_VAPORIZER] = "Listen Sie den Vaporizer-Hersteller und den Namen/das Modell auf";
translations[APPROXIMATELY_HOW_MUCH] = "Wie viel Flüssigkeit wurde ungefähr verschüttet?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "War die Flasche schwer in den Verdampfer einzuführen?";
translations[WERE_VISIBLE_DEFECTS] = "Gab es sichtbare Mängel?";
translations[SELECT_THE_OPTION] = "Wählen Sie die Option aus, die das Verbindungsproblem am besten beschreibt";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Geben Sie die Produktinformationen des zweiten Produkts an, das an dem Verbindungsproblem beteiligt war";
translations[WHICH_PART_SEPARATED] = "Welche Teile des Produkts haben sich gelöst?";
translations[WHAT_COMPONENT_DISCOLORED] = "Welche Komponente ist verfärbt?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Wählen Sie eine Option aus, die die Verfärbung am besten beschreibt:";
translations[WAS_THE_SET_DISCOLORED] = "War das Set verfärbt, als es aus dem Karton entnommen wurde?";
translations[DID_SET_CHANGE_COLOR] = "Hat das Set nach dem Hinzufügen von Medikamenten die Farbe geändert?";
translations[WHAT_MEDICATION_ADDED] = "Welches Medikament wurde vor dem Farbwechsel hinzugefügt?";
translations[WHERE_MATERIAL_LOCATED] = "Wo befand sich der Partikel/Fremdkörper?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Beschreiben Sie den Partikel/ das Fremdmaterial (Aussehen/Farbe/Größe):";
translations[WAS_EMBEDDED_PLASTIC] = "War der Partikel/das Fremdmaterial lose oder in den Kunststoff eingebettet?";
translations[WAS_THERE_A_PRECIPITATE] = "Gab es einen Niederschlag oder eine Veränderung der Farbe des Infusats/der Lösung, die nicht erwartet wurde?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "Welche Medikamente/Lösungen wurden durch das Set infundiert?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Wo war der Schaden oder welche Komponente (n) war betroffen (wählen Sie alle zutreffenden aus)?";
translations[WHAT_DAMAGE_ISSUE] = "Welche Art von Schaden/Problem wurde beobachtet (wählen Sie alles Zutreffende aus)?";
translations[DID_ISSUE_RESULT] = "Hat dieses Problem zu einem Leck geführt?";
translations[WAS_PATIENT_CONNECTED] = "War der Patient mit dem Produkt verbunden?";
translations[WAS_PRODUCT_REPLACED] = "Wurde das Produkt durch ein neues Produkt ersetzt?";
translations[WHICH_SITUATION_BEST] = "Welche Situation beschreibt am besten die Separation/Verbindungsproblem?";
translations[SELECT_MOST_LABELING_ISSUE] = "Wählen Sie die am besten geeignete Beschreibung des Kennzeichnungsproblems aus:";
translations[WHAT_INFORMATION_DISPLAYED] = "Welche Informationen wurden angezeigt?";
translations[WHAT_SCANNER_WAS_USED] = "Welche Art von Scanner wurde verwendet?";
translations[INCLUDE_THE_MODEL_NAME] = "Fügen Sie den Modellnamen ein";
translations[WAS_PRODUCT_ORDERED] = "Wurde das Produkt direkt bei Baxter oder einem anderen Händler bestellt?";
translations[WHERE_LEAK_COMING] = "Woher kommt das Leck (wählen Sie alles zutreffende aus)?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "Ist bei dem Leck eines der folgenden Szenarien aufgetreten?";
translations[WAS_POWER_INJECTOR] = "Wurde das Produkt mit einem Einspritzventil verwendet?";
translations[WHAT_INJECTOR_USED] = "Welches Einspritzventil wurde verwendet?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Hersteller, Produktname, Produktcode, Charge angeben";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Beschreiben Sie, was falsch, unvollständig, fehlend, unleserlich war oder auf dem Etikett geändert wurde:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Geben Sie die Produktinformationen des zweiten Produkts an, das an der Separation beteiligt war";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Bei welchen Komponenten wurde festgestellt, dass sie einen Riss oder Bruch hatten?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Beschreiben Sie die genaue Position auf dem Schlauch, der den Schnitt oder das Loch hatte:";
translations[WAS_LEAK_ORIGINATING] = "War das Leck an der Öffnung der Injektionsstelle";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Geben Sie die Produktinformationen des zweiten Produkts an, das an einem  Separations- oder Verbindungsproblem beteiligt war";
translations[WHICH_SPECIFIC_BONDED] = "Welche spezifischen  Komponenten haben sich gelöst?";
translations[WERE_VISIBLE_IRREGULARITIES] = "Gab es sichtbare Unregelmäßigkeiten/Schäden am betroffenen Produkt/den Komponenten";
translations[WAS_SUCCESSFUL_CONNECTION] = "Wurde schließlich eine erfolgreiche Verbindung oder Trennung hergestellt (ohne das Produkt ersetzen zu müssen)?";
translations[WAS_TOOL_USED_ASSIST] = "Wurde ein Tool verwendet, um bei der Verbindung/Trennung zu helfen?";
translations[WERE_LUER_CONNECTIONS] = "Wurden alle Luer-Verbindungen überprüft, um sicherzustellen, dass sie vor der Verwendung fest waren (entsprechend den Amweisungen auf dem Label)";
translations[WAS_PRODUCT_SECURELY] = "War das Produkt vor der Separationf fest mit einem anderen Produkt verbunden?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Welche Situation beschreibt das Flussproblem am besten?";
translations[WHAT_FLOWING_BACKWARDS] = "Was floss rückwärts?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Beschreiben Sie die Komponenten, von denen der Rückfluss bis zum Stillstand begann:";
translations[DO_SITUATIONS_APPLY] = "Gilt eine dieser Situationen für dieses Ereignis?";
translations[WHICH_SPECIFIC_AREA] = "Welcher spezifische Bereich des Sets oder der Komponente wurde mit den Flussproblemen verknüpft?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "Wurde zuvor der Fluss durch das Set oder die Komponente gesehen?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "Wurde einer der folgenden Punkte beobachtet:";
translations[WHERE_SIMULTANEOUS_FLOW] = "Wo war der Simultane Fluss dazwischen?";
translations[WHAT_TYPE_HANGER] = "Welche Art von Aufhänger wurde verwendet?";
translations[WHAT_WAS_HANGER_LENGTH] = "Wie lang war der Aufhänger, und wer ist der Hersteller?";
translations[WHICH_BAG_LOWER] = "Welcher Beutel war tiefer?";
translations[WHAT_Y_SITE_WAS] = "Mit welchem Y-Stück war das sekundäre Set verbunden?";
translations[WHAT_COMPONENT_WITHIN] = "Welche Komponente innerhalb des Sets kann nicht von Lösung oder Blut befreit werden?";
translations[WAS_COMPONENT_SET_REPLACED] = "Wurde die Komponente/das Set ersetzt, nachdem sie nicht durchgängig gemacht werden konnte?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "Wie hoch war das Flüssigkeitsvolumen, das dem Patienten infundiert werden sollte, und der vorgeschriebene Zeitraum?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "Wie hoch war das Flüssigkeitsvolumen, das dem Patienten über welchen Zeitraum tatsächlich infundiert wurde?";
translations[WAS_USED_WITH_PUMP] = "Wurde das Set mit einer Pumpe benutzt?";
translations[DID_CLAMP_FAIL] = "Hat eine Klemme versagt, den Fluss zu stoppen oder zu kontrollieren?";
translations[WHAT_CLAMP_FAILED] = "Welche Klemme hat nicht funktioniert?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Wurden Probleme mit der Kemme beobachtet?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "Beschreibt eine dieser anderen Situationen das Produktproblem (wählen Sie alles zutreffende aus)?";
translations[DESCRIBE_ALARM_OBSERVED] = "Beschreiben Sie den beobachteten Alarm:";
translations[INCLUDE_ANY_MESSAGES] = "Fügen Sie alle mit dem Alarm verbundenen Meldungen und Fehlercodes ein";
translations[WHICH_CLAMP_HAD_ISSUE] = "Welche Klemme hatte das Problem?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Welche Art von Klemmenproblem wurde festgestellt (wählen Sie alle zutreffenden aus)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Wählen Sie das Szenario aus, das das Problem am besten beschreibt:";
translations[PROVIDE_MORE_DETAILS] = "Geben Sie weitere Details darüber an, wie das Produkt schwierig zu verwenden war:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Geben Sie weitere Details zu den Anweisungen an, die schwer zu folgen/zu verstehen waren:";
translations[DESCRIBE_THE_SMELL] = "Beschreibe den Geruch und woher er kommt:";
translations[WAS_ISSUES_WITH_SET] = "Wurden Probleme mit dem Set beobachtet?";
translations[WHERE_LEAK_LOCATED] = "Wo an dem Produkt befand sich das Leck?";
translations[DID_OCCUR_WITH_LEAK] = "Ist bei dem Leck einer der folgenden Punkte aufgetreten?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Geben Sie die Produktinformationen des zweiten Produkts an, das an der Separation beteiligt war";
translations[DID_OCCURRED_WITH_THE_LEAK] = "Ist bei dem Leck eines der folgenden Szenarien aufgetreten?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Wo wurde das Produkt beschädigt?";
translations[SELECT_ALL_APPLY] = "Alles zutreffende auswählen";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Beschreiben Sie den beobachteten Schaden";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "Welche Komponente des Produkts war verfärbt?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Beschreiben Sie die beobachtete Farbe (Farbton, Schattierung usw.):";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "Innerhalb oder außerhalb des Umbeutels, Temperatur, Lichteinwirkung usw.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Beschreiben Sie die genaue Lage, Größe, Form und Farbe des Partikels/Fremdmaterials:";
translations[DOES_THE_PARTICULATE_MATTER] = "Scheint der Partikel/das Fremdmaterial Produktmaterial zu sein?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "Wurde der Partikel/das Fremdmaterial eingebettet?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "Scheint der Partikel-/das Fremdmaterial Teile des Produktmaterials zu sein?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Wo ist das Problem an dem Produkt aufgetreten?";
translations[LIST_COMPONENTS_IF] = "Listen Sie Komponenten auf. Wenn ein zweites Produkt beteiligt war, geben Sie Hersteller, Produktname, Produktcode und Charge an";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Wurden sichtbare Unregelmäßigkeiten/Schäden beobachtet?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Wählen Sie die Option aus, die das Fluss-Problem am besten beschreibt";
translations[DESCRIBE_IRREGULARITIES] = "Beschreiben Sie Unregelmäßigkeiten/Schäden und ob ein Schaden vor dem Verbinden/Trennen festgestellt wurde oder während dem Verbinden/Trennen aufgetreten ist";
translations[HOW_PRODUCT_SETUP] = "Wie war das Produkt-Setup?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Wählen Sie die am besten geeignete Beschreibung des Kennzeichnungsproblems aus:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Beschreiben Sie, was auf dem Etikett falsch, unvollständig, fehlend, unleserlich war oder was (einem anderen Produkt) auf dem Etikett zu ähnlich war:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "Wurde das Produkt im Versandkarton beschädigt?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "Welches Produkt sollte erhalten werden?";
translations[IF_PRODUCT_CODE_NOT] = "Wenn der Produktcode nicht verfügbar ist, geben Sie bitte die Produktbeschreibung an";
translations[WAS_THE_CASE_MISSING] = "Fehlten dem Karton Trockeneis oder gekühlte Gelpackungen?";
translations[WHAT_CARRIER_DELIVERED] = "Welcher Transporteur hat Ihr Produkt geliefert?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "Wie lautet die Bestellnummer?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "Wie hoch war die Anzahl fehlender Einheiten?";
translations[WAS_EXPIRED_PRODUCT_USE] = "Wurde das abgelaufene Produkt verwendet?";
translations[APPLY_TO_EACH_UNIT] = "Wenn das Problem an mehreren Einheiten beobachtet wurde, beziehen sich die untenstehenden Fragen auf jede Einheit.";
translations[TERMS_CONDITIONS] = " Allgemeine Geschäftsbedingungen";
translations[PRIVACY_POLICY] = " Datenschutzrichtlinie";
translations[PRIVACY_NOTICE] = "Datenschutzerklärung";
translations[COOKIE_POLICY] = " Cookie-Richtlinie";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Gefragt unbekannt";
translations[OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE] = "Baxter Mitarbeiter";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Betreuerin";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Distributor";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Gesundheitsexperte";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Patient";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Sonstiges";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Nach Gebrauch";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Vor dem Gebrauch";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "während der Einrichtung/ der Vorbereitung/ des Zusammensetzens";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "während der Therapie";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Mehrere Schritte";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "nicht angegeben";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Familienmitglied";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Krankenschwester";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Auszubildende Krankenschwester";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Sonstige medizinische Fachkraft";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Arzt";
translations[OPTION_UNITOPTIONS_BOXES] = "Boxen";
translations[OPTION_UNITOPTIONS_PALLETS] = "Paletten";
translations[OPTION_UNITOPTIONS_UNITS] = "Einheiten";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Alarm Zustand";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Schäden";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Schwer zu verwenden";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Verfärbte";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Strömungsprobleme";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Kennzeichnungsprobleme";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Lekage/Übermäßige Feuchtigkeit";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Feinstaubstoff/Fremdmaterial";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Patientenreaktion/Nebenwirkungen";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Produktanfrage";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Trennung/Verbindungsversandprobleme";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Versandprobleme/Abgelaufenes Produkt";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "weiblich";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Undifferenziert";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "männlich";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Sich weigern zu antworten";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Administrator/Betreuer";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Biomedizinischer Ingenieur";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = " Unternehmen Vertreter";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Zahnarzt";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Verteiler";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Familienmitglied";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Laienbenutzer";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Krankenschwester";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Auszubildende Krankenschwester";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Sonstige medizinische Fachkraft";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Apotheker";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Pharmazietechniker";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Arzt";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Patient";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Risikomanager";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Sonstiges";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Kontaktieren Sie einen zusätzlichen Ansprechpartner";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Kontaktieren Sie mich";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Kontaktieren Sie andere";
translations[OPTION_REPORTEDTOOPTIONS_BAXTER] = "Baxter";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "China FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Gesundheit Kanada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Japan)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TÜV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Australien)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = " Ein Haustier oder Tier hat das Problem verursacht";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Ein scharfes Objekt oder Werkzeug wurde verwendet, um den Karton oder den Überbeutel zu öffnen";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "Das Produkt war übermäßiger Kraft ausgesetzt (dh geschlagen, gestoßen, geschlagen usw.), bevor das Problem auftrat";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = " Das Produkt wurde in einer heißen/kalten Umgebung ausgesetzt oder gelagert";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Karton";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Minicap";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Beutel";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "Das Transferset war zu fest";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "Das Transferset war zu locker";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = " Das Transferset konnte nicht vollständig geschlossen werden";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = " Das Transferset konnte nicht vollständig geöffnet werden";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = " Die Drehklemme war so fest, dass das Transferset nicht geöffnet werden konnte";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = " Die Drehklemme war so fest, dass das Transferset nicht geschlossen werden konnte";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Ja - es gab einen Schaden/es war etwas nicht in Ordnung mit dem Gewinde des Transfersets, was verhinderte, dass es ornungsgemäß geschlossen werden konnte ";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Ja - dasr Minicap wurde von Hand oder mit einem Werkzeug zu stark an das Transferset angezogen";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Vollständig blockert, ohne dass Flüssigkeit fließt";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = " Eingeschränkter oder teilweiser Fluss (langsamer Fluss)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Geronnenes Blut";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = " Fibrin";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Knick";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Partikel";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = " Produktmaterial";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Überschüssiges Jod (braun) beim Anschluss oder in der Verpackung identifiziert";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Überschüssige Feuchtigkeit (klare Tröpfchen), die in der Verpackung identifiziert wurden";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = " Folienbeutel beschädigt vor Öffnung";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = " Paket/Box geöffnet oder beschädigt wurde";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = " Schwamm trocknet aus und ist weiß";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = " Schwamm trocknete aus mit bräunlicher Verfärbung";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = " In der Sekundärverpackung/Umbeutel";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Innerhalb des Produkt-/Fließweges";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = " Innerhalb des Versandkartons";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = " Auf der Außenseite des Produkts";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = " Auf der Außenseite der Sekundärverpackung/des Umbeutels";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = " Auf der Außenseite des Versandkartons";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Schwierigkeiten beim Verbinden des Produkts mit einem anderen Produkt";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Schwierigkeiten, das Produkt von einem anderen Produkt zu trennen";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = " Trennung von Komponenten eines einzelnen Produktes";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = " Produkttrennung/Trennung des Produkts von einem anderen Produkt";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "Ja - Rückstände am Gewinde";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "Ja - sichtbare Beschädigung";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Ja -  Andere (Freitext)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = " Frangible";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = " Aufhänger Loch";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = " Injektion/Füllung Port";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = " Membran Port";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Umbeutel/Beutel";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = " Patch";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = " Gummistopper";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = " Versandkarton";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = " Schrumpfband";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Lösungsbehälter";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = " Spitzenschutz";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = " Manipulationsschutz (Schrumpffolie)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = " Verbogen";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = " Gebrochen Zerbrochen";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Gerissen";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Zerschnitten";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Deformiert";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Abblättern";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Loch";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = " Geknickt";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Geschmolzen";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = " Patch Layer Separation";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = " Zerschlagen (Glas)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Geschnittenes";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Gerissen";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "Lösung floss gar nicht";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = " Lösung floss langsam";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = " Lösung floss gar nicht (oder langsam) während der Auflösung oder des Mischens";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = " Flasche";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Behälter";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = " Aufhänger";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = " Liner";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Umbeutel/Beutel";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = " Sauerstoffindikator";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = " Patch";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = " Ports";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = " Flüssigkeit";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = " Tip Protector";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = " Aminosäure-Kammer";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Dextrose Kammer";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = " Lipidkammer";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = " Untere Kammer";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = " Obere Kammer";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Geplatze/gerissene Schweißnaht";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "falsch montiertes Produkt/Teil";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Fehlende Komponente";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = " Trennung/Trennung verbundener Bauteile";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = " Produkt überfüllt";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Produkt unterfüllt";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Rekonstitution Issue ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = " In der sekundären Verpackung/Umrbeutel";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = " Innerhalb des Versandkartons";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = " Auf der Außenseite des Versandkartons";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Innerer Fließweg";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = " Im Verdampferbehälter (Schauglas)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "Auf der äußeren Oberfläche des Produkts";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = " Auf der Außenseite der Sekundärverpackung/des Umbeutels";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = " Auf dem Sauerstoffabsorber";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = " Auf dem transdermalen Pflaster";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = " Frangible";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = " Glaspartikel";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Port";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = " Gummistopfen";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Tubing";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = " Nach Zugabe eines anderen Medikaments oder nach Rekonstitution (Fläschchen)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Vor dem Spiken oder der Rekonstitution";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = " Kalt (aufgetaut aber noch nicht Raumtemperatur)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Gefroren";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Teilweise aufgetaut (Eiskristalle in Lösung)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = " Raumtemperatur";
translations[OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING] = " Baxter Auftaueinheit (BTU) Bei Raumtemperatur";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = " Bei Raumtemperatur belassen";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Kühlschrank";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Ja - es gab Hinweise auf Schäden während des Versands";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Ja - es wurde ein Leck beobachtet";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = " Ja - es gab ein Loch oder eine unvollständige Schweißnaht im Umbeutel";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = " Ja - es gab Schwierigkeiten beim Spiken oderder  Rekonstitution";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = " Ja - es gab Schwierigkeiten, das Knickventil zu brechen";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = " Ja - es gab Kristallisation oder Niederschlag der Lösung";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = " Ja - es gab Trübung/Niederschlag in Frozen Galaxy Produkt";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "Das Produkt hatte keine beabsichtigte Wirkung oder war unwirksam (fehlende Wirkung)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Unbeabsichtigte Wirkung/Reaktion. Bitte geben Sie an: (Freitext)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Beschädigter Versandkarton während der Lieferung";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = " Abgelaufenes Produkt geliefert";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = " Abgelaufenes Produkt gefunden";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = " Barcode-Problem - Falsche Informationen werden beim Scannen angezeigt";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = " Barcode-Schwierigkeiten beim Scannen/nicht scannbarer Barcode";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = " Abgelaufenes Produkt geliefert";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = " Abgelaufenes Produkt gefunden im Bestand";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = " Unlesbares Etikett";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Falsches Etikett";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Unvollständiges Etikett";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = " Etikett ist zu ähnlich wie bei einem anderen Produkt";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = " Etiketten (Produkt, Karton/Karton, Versandliste) haben nicht die gleichen Produktinformationen";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = " Fehlender Barcode";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "falsches Produkt oder verwechselte Produkte";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Beschädigter Versandkarton während der Lieferung";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Zusätzliche Einheiten wurden erhalten";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = " Abgelaufenes Produkt geliefert";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = " Abgelaufenes Produkt gefunden";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Ein Teil des Kartons wurde geöffnet oder war nicht verschlossen";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = " Produktinformationen auf dem Karton und das Versandsetikett stimmten nicht mit dem Produkt im  Karton überein ";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = " Einheiten fehlten";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = " Fehlendes Etikett";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = " Ablaufdatum";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = " Charge";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = " NDC-Nummer";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = " Tröpfchen/Feuchtigkeit im Umbeutel vorbei, ohne dass Leck beobachtet wird";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Leck";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = " Leck beobachtet, wenn der Beutel gequetscht wird";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = " Lösung fließt an den Knickventilen vorbei";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = " Lösung im Umbeutel, ohne dass Leck beobachtet wird";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = " Zwischen Überbeutel und Primärbehälter";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = " Verbindung zwischen zwei Produkten";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Behälter - Membranport/Schlauch";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Behälter - Injektions-/Füllstutzen";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Behälter - Beutelaufhänger";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Behälter";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = " Frangible";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = " Gummistopper";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = " Schrumpfband";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = " Spitzenschutz";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = " Vial Adapter";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Verklebter Port";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Schäden (Löcher, Risse) an der Sekundärverpackung oder dem Zwischenkarton";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = " Exposition gegenüber extrem heißen/kaöten Temperaturen";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = " Leak an der Vaporizer-Schnittstelle";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = " Öffnen des Versandkartons mit einem Kartonschneider/scharfen Gegenstand";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = " Haustiere (zerkratzt/zerkaut)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = " Lösungsbeutel unter Druck mit einer Druckmanschette oder einem anderen Gerät";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = " Anhaftender Hafen";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Schäden (Löcher, Risse) an der Sekundärverpackung oder dem Zwischenkarton";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = " Beschädigter Versandkarton während der Lieferung";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = " Exposition gegenüber extrem heiß/kalt";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = " Leak an der Vaporizer-Schnittstelle";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = " Öffnen des Versandkartons mit einem Kartonschneider/scharfen Gegenstand";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = " Haustiere (zerkratzt/zerkaut)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = " Lösungsbeutel unter Druck mit einer Druckmanschette oder einem anderen Gerät";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = " Keine der oben genannten";
translations[NO_DESCRIBE_THE_COLOR] = " Nein - beschreibe die Farbe (Freitext)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10 ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = " größer als 10 mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Weniger als 1 mL";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = " Flasche";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Deckel";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "Ventil/Hals";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = " Keine";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Schwierigkeiten beim Verbinden des Produkts mit einem anderen Produkt";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Schwierigkeiten, das Produkt von einem anderen Produkt zu trennen";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = " Trennung von Komponenten eines einzelnen Produktes";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = " Produkttrennung/Trennung des Produkts von einem anderen Produkt";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Tropfkammer";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Schlauch";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = " Sonstiges - Bitte angeben (Freitext)";
translations[OTHER_PLEASE_SPECIFY] = " Sonstiges - Bitte angeben (Freitext)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Trüb";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Gelb/Bräunlich";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = " Andere - Bitte angeben (Freitext)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = " In Primärverpackungs/Blisterbeutel";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "Innerhalb des IV-Flusswegs (im Schlauch)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = " Innerhalb des Versandkartons";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = " Auf der Außenseite des Versandkartons";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = " Außerhalb des IV-Flusswegs (Außenseite des Schlauches)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = " Eingebettet";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Lose";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = " Nicht zutreffend";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = " Beschreibe Farbe (Freitext)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = " Ja - Farbwechsel";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Ja - Niederschlag";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Zugangsseite";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = " Burrettes";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = " Klemme";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Tropfkammer";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = " Schläuche";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = " Filter";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = " Luer Connector";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Spike";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Schnitte/Gebrochene/Komponente (en)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = " Falsche Komponentenmontage - Bitte angeben (Freitext)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Verknickte Komponente (en)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = " Lose Komponente (en) innerhalb der Verpackung";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = " verformte/unförmige Komponente (en)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = " Fehlende Komponente";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = " Schwierigkeiten beim Verbinden des Produkts mit einem anderen Produkt";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = " nicht miteinander verbunden werden";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = " Lose Verbindung";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Trennung/Trennung des Produkts von einem anderen Produkt";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Trennung zwischen zwei verklebten Komponenten eines einzigen Produkts";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = " Keine Verbindung - zwei Produkten können";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = " Schwierigkeiten, das Produkt von einem anderen Produkt zu trennen ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = " Barcode-Problem - Falsche Informationen werden beim Scannen angezeigt";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = " Änderung der Etiketten (Produkt, Versandkarton/ Produktkarton)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Barcode/UDI-Schwierigkeiten beim Scannen";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Verfallenes Produkt";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Falsche Informationen auf dem Etikett";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = " Fehlender Barcode/UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = " Fehlende Informationen auf dem Etikett";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = " Produkt ohne Verfalldatum";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = " Etikettenflecken/Problem mit unleserlicher Etikettierung ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = " Karton überein. Karton enthält ein falsches Produkt oder gemischtes Produkt";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Beschädigter Versandkarton während der Lieferung";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = " Abgelaufenes Produkt geliefert";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = " Abgelaufenes Produkt gefunden";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER] = "Baxter";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR] = "Vertriebspartner";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = " Zusätzliche Einheiten wurden erhalten";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = " Ein Teil des Kartons wurde geöffnet oder nicht verschlossen";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = " Produktinformationen auf dem Karton und das Versandsetikett stimmten nicht mit dem Produkt im";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = " Einheiten fehlten";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = " Zugangsstelle";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Entlüftung";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Bürette";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Deckel";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Clearlink Injektionsstelle";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = " Klemme";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = " Tropfkammer";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = " Filter";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Interlink Injektionsstelle";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = " Luer-Steckverbinder";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Spike";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = " Schläuche";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = " Leck zwischen der Injektionsstelle und dem Schlauch";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = " Nadelbasierte Injektionsstelle";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = " Ein-Link Injektionsstelle";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = " Andere Injektionsstelle (Freitextt)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = " Risse/Brüche von starren Set-Komponenten";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = " Schnitt/Riss im weichen Schlauch";
translations[DISCONNECTION_OF_CONNECTABLE] = "Trennen von verbindbaren Komponenten/verbundenen Produkten";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Trennen von verbindbaren Komponenten/verbundenen Produkten";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Trennung von verbundenen Komponenten";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Ja - Beschreibe Unregelmäßigkeiten/Schaden (Freitext)";
translations[YES_SPECIFY_THE_TOOL] = "Ja - Geben Sie das verwendete Tool an (Freitext)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = " Rückfluss";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = " Klemmenfehler - Schließen schwer, aber möglich";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = " Klemmenfehler - Kann nicht vollständig geschlossen werden ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Klemmenfehler - Öffnen Schwierig/nicht möglich ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Kein Flluss";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Überinfusion";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = " eingeschränkt/langsamer";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = " Simultaner Fluss ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Reinigen der Komponente nicht möglich";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Primen micht möglich";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Unterinfusion";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Blut des Patienten (keine Blutprodukte werden infundiert)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Lösungen/Blutprodukte";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Undichtigkeit/Loch";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Lösen der Verbindung";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Leck";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "Medikamente wurden über eine unter Druck stehende";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = " Infusionsspritze oder IV-Pumpe verabreicht Der Sekundärbeutel war niedriger als der Primärbeutel";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "Sekundärbeutel war auf der gleichen Höhe wie der Primärbeutel";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Blutgerinnung";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = " Katheter konnte nicht gespült werden vor Anschluss ans Set";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "geknickter Schlauch";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = " Blockierung des Schlauchs/der Injektionsstelle";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Primär- und Sekundärbehälter (Huckepack)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Zwei oder mehr Leitungen fließen in einem Mehrwegeschlauch";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = " Zwei Verabreichungssätze mit jeweils einer eigenen Infusionspumpe";
translations[OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER] = "Baxter Aufhänger";
translations[OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER] = "Non-Baxter Aufhänger";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = " Taschen waren auf gleicher Höhe";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Primär";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Sekundär";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Mitte";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = " Unten";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Oben";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Ja - Geben Sie den Namen und den Produktcode der Pumpe an (Freitext)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Dunkelblaue Schiebeklemme";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Hellblaue Schiebeklemme";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = " Kerbenklemme";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Rollklemme";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = " Weiße Schiebeklemme";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Ja - die Klemme war gebrochen oder gerissen";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = " Luft im Schlauch";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Klemmenproblem";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = " Geruch";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Kerbenklemme";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Rollenklemme ";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Schiebeklemme";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = " Gerissen/Gebrochen";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = " Schwer zu öffnen";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = " Schwer zu schließen ";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = " Fehlend";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Kann nicht geöffnet werden";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = " Kann nicht geschlossen werden";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = " Fluss kann nicht kontrolliert werden";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = " Schließen der Tropfkammer schwierig";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Anweisungen waren schwer zu folgen/zu verstehen";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "Produkt war schwer zu verwenden";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = " Riss/Bruch";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Schnitt";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Trennen von verbindbaren Komponenten/verbundenen Produkten";
translations[DISCONNECTION_OF_CONNECTABLE] = "Trennen von verbindbaren Komponenten/verbundenen Produkten";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = " Loch/Riss";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Trennung von verbundenen Komponenten";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = " Anhaftender Hafen";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Schäden (Löcher, Risse) an der Sekundärverpackung oder dem Zwischenkarton";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = " Beschädigter Versandkarton während der Lieferung";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = " Exposition gegenüber extrem heiß/kalt";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = " Öffnen des Versandkartons mit einem Kartonschneider/scharfen Gegenstand";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = " Keine der oben genannten";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = " Druckmanschette oder Druckinjektor verwendet";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Verklebter Port";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Haustiere (klauen/gekaut)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Produkt";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = " Versand Karton/Produktkarton";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "Innerhalb des Produkts";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = " Innerhalb des Versandkartons";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = " Auf der Außenseite des Produkts";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Schwierigkeiten beim Verbinden des Produkts mit einem anderen Produkt";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Schwierigkeiten, das Produkt von einem anderen Produkt zu trennen";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = " Lose Verbindung";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Trennung von Komponenten eines einzelnen";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Produktes/Trennung des Produkts von einem anderen Produkt";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = " Auf der Außenseite des Versandkartons";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = " Auf der Innenseite der Sekundärverpackung/des Überbeutels";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = " Auf der Außenseite der Sekundärverpackung/des Überbeutels";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Kein Fluss";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = " eingeschränkter oder teilweiser Fluss";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = " Barcode-Problem - Falsche Informationen werden beim Scannen angezeigt";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = " Barcode-Schwierigkeiten beim Scannen/nicht scannbarer Barcode";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = " Unlesbares Etikett";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Falsches Etikett";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = " Unvollständiges Etikett";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = " Barcode-Etiketten (Produkt, Karton, Lieferschein) haben nicht die gleiche Produktinformation";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = " Etikett ist zu ähnlich wie bei einem anderen Produkt";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = " Fehlendes Etikett";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = " Fehlender Barcode";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = " Gefroren Produkt wurde erhalten";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "Aufgetautes Produkt wurde erhalten";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Ja, Alarm nicht bekannt";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Ja, spezifizieren";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Ja - das Transferset konnte nicht vollständig geöffnet werden";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Ja - das Transferset konnte nicht vollständig geschlossen werden";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "Ja - Die Drehklemme war so fest, dass das Transferset nicht geöffnet werden konnte";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "Ja - Die Drehklemme war so fest, dass das Transferset nicht geschlossen werden konnte";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Karton oder Umbeutel";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = " Blaue Klemme am Füllschlauch";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = " Kassette";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = " Ablaufleitung und Zugringkappe";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = " Abwasserprobenseite";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Schläuche";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = " Luer/Spike-Steckverbinder";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = " Organizer";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Zug-Ring-Kappe/Spitzenschutz an der Patientenleitung";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Zugringkappe/Tip Protectors";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = " Rote Klemme an Heizungsleitung";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = " Tack Weld?";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = " Weiße Klemme an Versorgungsleitung";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = " Beiger Katheter-Adapter-Anschluss";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = " Chip-Einsatz";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Dunkelblauer Verbinder";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Hellblauer Hauptkörper";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = " Hellblauer Pull Ring Cap";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = " Hellblaue OkkluderLegs";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = " Silikonschlauch";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = " Titan Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = " UV Flash Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = " Weiße Drehklemme";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Ja: Beschreibe den Schaden (Freitext)";
translations[OPTION_MONTHOPTIONS_JAN] = "Jan";
translations[OPTION_MONTHOPTIONS_FEB] = "Feb";
translations[OPTION_MONTHOPTIONS_MAR] = "Mär";
translations[OPTION_MONTHOPTIONS_APR] = "Apr";
translations[OPTION_MONTHOPTIONS_MAY] = "Mai";
translations[OPTION_MONTHOPTIONS_JUN] = "Jun";
translations[OPTION_MONTHOPTIONS_JUL] = "Jul";
translations[OPTION_MONTHOPTIONS_AUG] = "Aug";
translations[OPTION_MONTHOPTIONS_SEP] = "Sep";
translations[OPTION_MONTHOPTIONS_OCT] = "Okt";
translations[OPTION_MONTHOPTIONS_NOV] = "Nov";
translations[OPTION_MONTHOPTIONS_DEC] = "Dez";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Andere";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = " Sonstiges";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = " Andere (Freitext)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = " Keine der oben genannten";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "Nein";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Ja";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "Nein";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Ja";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "Nein";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Ja";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "Nein";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Ja";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Gefragt unbekannt";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "Nein";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Unbekannt";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Ja";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "Nein";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Ja";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "Nein";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Ja";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "Nein";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Ja";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "Nein";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Ja";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "Nein";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Ja";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "Nein";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Ja";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "Nein";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Ja";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "Nein";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Ja";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "Nein";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Ja";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "Nein";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Ja";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "Nein";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Ja";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "Nein";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Ja";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "Nein";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Ja";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "Nein";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "Nein";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Ja";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "Nein";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Ja";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "Nein";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Ja";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "Nein";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Ja";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "Nein";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Ja";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "Nein";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Ja";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "Nein";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Ja";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "Nein";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Ja";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "Nein";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Ja";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "Nein";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Ja";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "Nein";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "Nein";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Ja";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "Nein";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Ja";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "Nein";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Ja";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "Nein";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Unbekannt";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Ja";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "Nein";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Ja";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "Nein";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Ja";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "Nein";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Ja";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "Nein";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Ja";
translations[OPTION_vaporizerSightGlassOptions_NO] = "Nein";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Unbekannt";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Ja";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "Nein";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Ja";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "Nein";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Ja";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "Nein";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Ja";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "Nein";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "Nein";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "Nein";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Ja";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "Nein";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Ja";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "Nein";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Ja";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "Nein";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Ja";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "Nein";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Unbekannt";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Ja";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "Nein";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Ja";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "Nein";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "Nein";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Ja";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "Nein";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Ja";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "Nein";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Ja";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "Nein";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Ja";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "Nein";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Ja";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "Nein";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Ja";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "Nein";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Ja";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Ja";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "Nein";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Ja";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "Nein";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Ja";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "Nein";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Ja";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "Nein";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Ja";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "Nein";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Ja";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "Nein";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Ja";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "Nein";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "Nein";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Ja";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "Nein";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Ja";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "Nein";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Ja";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = " Nein";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "Nein";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Ja";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = " Nein";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "Nein";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Ja";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "Nein";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Ja";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "Nein";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Ja";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "Nein";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Ja";
translations[OPTION_WITHPUMPOPTIONS_NO] = "No";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "Nein";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Ja";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = " Nein";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "Nein";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Ja";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "Nein";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Ja";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "Nein";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Ja";
translations[OPTION_GELPACKSOPTIONS_NO] = "Nein";
translations[OPTION_GELPACKSOPTIONS_YES] = "Ja";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "Nein";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Ja";
translations[OPTION_ALARMOPTIONS_NO] = " Nein";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "Nein";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Ja";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "Nein";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "Nein";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Ja";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "Nein";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Ja";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "Nein";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Unbekannt";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "Nein";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Ja";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = " Andere (Freitext)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "Nein";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Ja";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "Nein";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Ja";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "Nein";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Gefragt unbekannt";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Gefragt unbekannt";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = " Nein";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = " UNK";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = " Keine der oben genannten";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = " Nein - beschreibe die Farbe (Freitext)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Ja - Geben Sie das verwendete Tool an (Freitext)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Lösen";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = " Keine";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Ja -  Andere (Freitext)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = " Keine";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Kilogramm €";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "Pfund (s)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = " Nein";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Unbekannt";
translations[PLEASE_ENTER_THE_VALUE] = "Bitte geben Sie den Wert ein";
translations[PLEASE_SELECT_THE_VALUE] = "Bitte wählen Sie den Wert";
translations[PLEASE_SELECT_THE_DATE] = "Bitte wählen Sie das Datum aus.";
translations[PLEASE_CHOOSE_THE_VALUE] = "Bitte wählen Sie den Wert";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Unbekannt";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "GROSSBRITANNIEN";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "NORDIRLAND";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGHANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ALAND INSELN";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBANIEN";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ALGERIEN";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "AMERIKANISCH SAMOA";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORRA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILLA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTARKTIS";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA UND BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINIEN";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIEN";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRALIEN";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "ÖSTERREICH";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "ASERBAIDSCHAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHRAIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESCH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BELARUS";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BELGIEN";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDA";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BHUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIVIEN";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOSNIEN UND HERZEGOWINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "BOUVET-INSEL";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRASILIEN";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "BRITISCHES TERRITORIUM DES INDISCHEN OZEANS";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BULGARIEN";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "KAMBODSCHA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "KAMERUN";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "KANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "KAP VERDE";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "CAYMAN INSELN";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "ZENTRALAFRIKANISCHE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "TSCHAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CHINA ";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "WEIHNACHTSINSELN";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "COCOS (KEELING) INSELN";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "KOLUMBIEN";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "KOMOREN";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "KONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "KONGO, DEMOKRATISCHE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "COOKINSELN";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "ELFENBEINKÜSTE";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "KROATIEN";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "KUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "ZYPERN";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "TSCHECHISCHE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DÄNEMARK";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DSCHIBUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINIKA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "DOMINIKANISCHE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "ECUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "ÄGYPTEN";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "ÄQUATORIALGUINEA";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTLAND";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ÄTHIOPIEN";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "FALKLANDINSELN (MALVINAS)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "FÄRÖER INSELN";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINNLAND";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANKREICH";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "FRANZÖSISCH-GUAYANA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "FRANZÖSISCH POLYNESIEN";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "SÜDFRANZÖSISCHE TERRITORIEN";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABUN";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEORGIEN";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "DEUTSCHLAND";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GRIECHENLAND";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GRÖNLAND";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRENADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADELOUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINEA";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEA-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUYANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "HEARD ISLAND UND MCDONALD-INSELN";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "HEILIGER STUHL (STAAT VATIKANSTADT)";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONGKONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "UNGARN";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ISLAND";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "INDIEN";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONESIEN";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN, ISLAMISCHE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAK";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRLAND";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "ISLE OF MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAEL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "ITALIEN";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAIKA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "JAPAN";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDANIEN";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KASACHSTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENIA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "KOREA, DEMOKRATISCHE VOLKSREPUBLIK";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "KOREA, REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWAIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KIRGISISTAN";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "LAOS, DEMOKRATISCHE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LETTLAND";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LIBANON";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTHO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBYANISCHES ARABISCHES JAMAHIRIYA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITAUEN";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUXEMBURG";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MAZEDONIEN, EHEMALIGE JUGOSLAWISCHE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASKAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALAYSIA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALEDIVEN";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "MARSHALLINSELN";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINIQUE";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURETANIEN";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURITIUS";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAYOTTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MEXIKO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "MIKRONESIEN, FÖDERIERTE STAATEN";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDAWIEN";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLEI";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MAROKKO";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOSAMBIK";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "NIEDERLANDE";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NEU-KALEDONIEN";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NEUSEELAND";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "NORFOLKINSEL";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "NÖRDLICHE MARIANNENINSELN";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NORWEGEN";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "BESETZTE PALÄSTINENSISCHE GEBIETE";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA NEU-GUINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAY";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "PHILIPPINEN";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLEN";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTUGAL";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "KATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "RUMÄNIEN";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "RUSSISCHE FÖDERATION";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RUANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "ST. BARTHÉLEMIE";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "ST. HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "ST. KITTS UND NEVIS";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "ST. LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "ST. MARTIN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "ST. PIERRE UND MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "ST. VINCENT UND DIE GRENADINEN";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SAO TOME UND PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "SAUDI ARABIEN";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERBIEN";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEYCHELLEN";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPUR";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "SLOWAKEI";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "SLOWENIEN";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "SALOMON-INSELN";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "SÜDAFRIKA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "SÜD-GEORGIEN UND DIE SÜDLICHEN SANDWICH-INSELN";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "SPANIEN";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAM";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD UND JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SWASILAND";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "SCHWEDEN";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "SCHWEIZ";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SYRISCHE ARABISCHE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAIWAN, R.O.C.";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TADSCHIKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANSANIA, VEREINIGTE REPUBLIK";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "THAILAND";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD UND TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNESIEN";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "TÜRKEI";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "TURKS- UND CAICOS-INSELN";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UKRAINE";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "VEREINIGTE ARABISCHE EMIRATE";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "VEREINIGTES KÖNIGREICH";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "VEREINIGTE STAATEN";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "KLEINERE VORGELAGERTE INSELN DER VEREINIGTEN STAATEN";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAY";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "USBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIETNAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "JUNGFERNINSELN, BRITISCH";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "JUNGFERNINSELN, USA";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS UND FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "WESTSAHARA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "JEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "SAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "SIMBABWE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "Nein";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Unbekannt";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Ja";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Ich habe die verlinkte Datenschutzerklärung für das Baxter Produkt-Feedback-Portal gelesen und verstanden. ";
translations[PRODUCT_LOT] = "Chargenbezeichnung(en)";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Versand-/Verteilungsetikett";
translations[CARTON_LABEL] = "Karton-Etikett";
translations[INTERNAL_PRODUCT_LABEL] = "Interne Produktetikette";
translations[TITLE_PD_RENAL] = "PD Renal";
translations[TITLE_SOLUTIONS] = "Lösungen";
translations[TITLE_ACCESS] = "Zugang";
translations[TITLE_ALL_OTHER_PRODUCT] = "Alle anderen Produkte";
translations[REPORTED_PROBLEM] = "Gemeldetes Problem";
translations[LOGIN] = "Anmeldung";
translations[SYSTEM_MENU] = "Systemmenü";
translations[INITIATE_PRODUCT_FEEDBACK] = "Initiere Produktrückmeldung";
translations[FEEDBACK_STATUS] = "Feedback-Status";
translations[OKTACALLBACK] = "OktaRückruf";
translations[VALID_EMAIL] = "Bitte geben Sie eine gültige E-Mail-Adresse ein";
translations[VALID_NUMERIC] = "Bitte geben Sie die gesamte Nummer ein";
translations[PLEASE_UPLOAD_IMAGE] = "Bitte lade Bild (er) hoch";
translations[VALID_DATE] = "Bitte wähle ein gültiges Datum aus";
translations[QUANTITY] = "Menge";
translations[EDIT] = "Bearbeiten";
translations[DELETE] = "Löschen";
translations[LOT_SERIAL_NO] = "Chargen-/Seriennr";
translations[LOT_NUMBER_NOT_FOUND] = "Charge nicht gefunden";
translations[SEARCHING_LOT_NUMBER] = "Suche nach der Chargennummer";
translations[PRODUCT_CODE_NOT_FOUND] = "Artikelnummer nicht gefunden";
translations[SEARCHING_PRODUCT_CODE] = "Suche nach der Artikelnummer";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Dateien mit folgenden Endungen (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) sind nicht erlaubt.";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "Die Datei, die Sie anhängen möchten, überschreitet die erlaubte Größe. Bitte komprimieren Sie sie, oder hängen eine andere Datei an.";
translations[IMAGE_ICON] = "Klicken Sie auf das Bild-Icon, um die Option auszuwählen.";
translations[LOGIN_TO_ACCOUNT] = "Melden Sie sich beim Konto an";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Melden Sie sich bei Ihrem Konto an";
translations[BAXTER_EMAIL_ADDRESS] = "Baxter-E-Mail-Adresse";
translations[PASSWORD] = "Passwort";
translations[SIGN_IN] = "Einloggen";
translations[UNKNOWN] = "Unbekannt";
translations[ASKED_UNKNOWN] = "Gefragt unbekannt";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Land auswählen";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Chinesisch (Vereinfachtes Chinesisch)";
translations[DUTCH] = "Niederländisch";
translations[ENGLISH] = "Englisch";
translations[FRENCH] = "Französisch";
translations[GERMAN] = "Deutsch";
translations[ITALIAN] = "Italienisch";
translations[JAPANESE] = "Japanisch";
translations[KOREAN] = "Koreanisch";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandarin (Traditionelles Chinesisch)";
translations[POLISH] = "Polnisch";
translations[PORTUGUESE] = "Portugiesisch";
translations[SPANISH] = "Spanisch";
translations[THAI] = "Thailändisch";
translations[TURKISH] = "Türkisch";
translations[VIETNAMESE] = "Vietnamesisch";
translations[BROWSE] = "Durchsuche";
translations[FEEDBACK_SUBMITTED] = "Feedback gesendet";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "Ihr Feedback zur Produkterfahrung wurde erfolgreich übermittelt. Danke für Ihren Bericht. Sie erhalten eine E-Mail mit einer Referenznummer. Als Anbieter von Medizinprodukten sind Kundenzufriedenheit und Rückmeldungen zu unseren Produkten unerlässlich für unser Ziel, Produkte von höchster Qualität anzubieten. Kontaktieren Sie bitte";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "wenn Sie Fragen oder zusätzliche Informationen haben.";
translations[CLOSE] = "Schließen";
translations[PATIENT_AGE] = "Alter des Patienten";
translations[ENTER_AGE] = "Alter eingeben";
translations[PATIENT_DOB] = "Geburtsdatum des Patienten";
translations[RELEVANT_ATTACHMENTS] = "Bitte stellen Sie alle relevanten Anhängezur Verfügung";
translations[BAXTER_ACCOUNT_CREDENTIALS] = "Geben Sie Ihre Baxter-Kundennummer ein";
translations[GET_PRODUCT_DETAILS] = "Produktdetails abrufen";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Verwenden Sie das obige Diagramm (Abbildung 2), um den Ort des gemeldeten Problems zu bestimmen";
translations[FACILITY_ADDRESS] = "Anschrift der Einrichtung";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Eine weitere Einrichtngs-Adresse";
translations[CHOOSE_PRODUCT_CODE] = "Bitte wählen Sie den zur eingegebenen Charge/Seriennummer zugehörigen Produktcode";
translations[DECLINE] = "Ablehnen";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT EUSTATIUS UND SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURACAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "SÜDSUDAN";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "zeigt an, dass Hilfetext für dieses Feld verfügbar ist";
translations[YOUR_FIRST_NAME] = "Ihr Vorname";
translations[YOUR_LAST_NAME] = "Ihr Nachname";
translations[MY_FIRST_NAME] = "Mein Vorname";
translations[MY_LAST_NAME] = "Mein Nachname";
translations[PATIENT_FIRST_NAME] = "Vorname des Patienten";
translations[PATIENT_LAST_NAME] = "Nachname des Patienten";
translations[REPORTER_FIRST_NAME] = "Vorname des Reporters";
translations[REPORTER_LAST_NAME] = "Nachname des Reporters";
translations[EMPLOYEE_FIRST_NAME] = "Vorname des Mitarbeiters";
translations[EMPLOYEE_LAST_NAME] = "Nachname des Mitarbeiters";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Vorname des Endkundens/Kundenkontakts";
translations[END_USER_CUSTOMER_LAST_NAME] = "Nachname des Endkundens/Kundenkontakts";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Vorname des zusätzlichen Kontakts";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Nachname des zusätzlichen Kontakts";
translations[COPYRIGHT] = "Copyright ©";
translations[COPYRIGHT_BAXTER] = "Baxter";
translations[COPYRIGHT_VERSION] = "Alle Rechte vorbehalten | Version";
translations[ADD_ADDITIONAL_CONTACT] = "Zusätzlichen Kontakt hinzufügen";
translations[CONTACT_ME] = "Der Kunde möchte nicht kontaktiert werden. Kontaktieren Sie mich für weitere Fragen.";
translations[DO_NOT_CONTACT] = "Nicht kontaktieren";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Name der Einrichtung (Endkunde)";
translations[END_USER_CUSTOMER_PHONE] = "Telefonnummer der Einrichtung (Endkunde)";
translations[END_USER_CUSTOMER_EMAIL] = "E-Mail-Adresse der Einrichtung (Endkunde)";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Adresse der Einrichtung (Endkunde) ";
translations[SAME_AS_PATIENT_ADDRESS] = "Gleiche Adresse wie Patienten";
translations[SAME_AS_REPORTER_ADDRESS] = "Gleiche Adresse wie des Melders";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Gleiche Adresse wie der Einrichtung (Endkunde) ";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Verwenden Sie das obige Diagramm (Abbildung 3), um die Stelle des gemeldeten Problems zu ermitteln";
translations[CONTACT_US] = "Kontaktiere uns";
translations[LANDING_BRIEF_FOR_DEVICE] = "Im Falle von Geräte-Reparaturen, Service- oder Technischen Support-Anfragen, wenden Sie sich bitte an Ihr lokales Technik Kontaktteam.";
translations[PATIENT_SEX] = "Geschlechtsidentität";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Cisgender-Mann/Junge";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Cisgender-Frau/Mädchen";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Transgender-Mann/Trans-Mann/Frau-zu-Mann";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Transgender-Frau/Transfrau/Mann-zu-Frau";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Andere Geschlechtskategorie; Bitte angeben";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Sich weigern zu antworten";
translations[ATTENTION_NEEDED] = "!!! DRINGENDE AUFMERKSAMKEIT ERFORDERLICH: Ihre Einreichung im Produktfeedback-Portal ist FEHLGESCHLAGEN!";
translations[SUBMIT_ERR_MSG] = "Um die Beschwerde erneut einzureichen, klicken Sie bitte auf OK und dann auf Senden oder senden Sie Ihre Beschwerde per E-Mail an (@@@).";
translations[SUBMIT_RETRY_MSG] = "Wenn Sie erneut eingereicht haben, überprüfen Sie bitte, ob Sie eine Bestätigungs-E-Mail vom Produktfeedback-Portal in Ihrem E-Mail-Postfach erhalten haben. Wenn keine Bestätigungs-E-Mail eingegangen ist, war die Übermittlung nicht erfolgreich, und Sie MÜSSEN Ihre Beschwerde per E-Mail an (@@@) senden.";
translations[OK] = "OK";

export default lang;